import { useState, useRef, useEffect, useCallback } from "react";

/* ── CONSTANTS ── */
const PAYPAL_CLIENT_ID = "AbXsq1O_uDZGBDZs9K55RQdwbfS6FoZyIQUg1rx2xTMDzmuS44mqvkBNP1SE6sbgC0Nw8vGA1z4CO6zY";
const PAYPAL_PLAN_ID   = "P-4PF92811N6752470LNIZOEVQ";
const EMAILJS_SERVICE  = "service_xejoaha";
const EMAILJS_TEMPLATE = "template_qc11nla";
const EMAILJS_KEY      = "4omm_l2ohdDgKdYsa";
const NOTIFY_EMAIL     = "detailedbydenise@outlook.com";
const STORE_KEY        = "contentsync_v2";
const ACCESS_KEY       = "contentsync_access";
const PREPARER_KEY     = "contentsync_preparer";
const CODES_KEY        = "contentsync_codes";
// Universal expiry store: { "SSDD-XXXX": "2026-08-01", ... } for ANY user
// (legacy or generated). Lets us schedule deactivation for legacy users who
// aren't in the editable CODES_KEY list.
const EXPIRY_KEY       = "contentsync_expiry";
const THEME_KEY        = "cs_theme";
const GRACE_DEADLINE   = "2026-07-17";

const LEGACY_USERS = [
  {code:"SSDD-ADMIN7655",name:"Admin",email:"",role:"admin"},
  {code:"SSDD-BETA2026",name:"Beta User",email:"",role:"beta"},
  {code:"SSDD-ALDY23",name:"Amanda Lee Lawler",email:"mandy@mlawlit.com",role:"user"},
  {code:"SSDD-KH3238",name:"Kailee Howell",email:"kevans432@gmail.com",role:"user"},
  {code:"SSDD-NHOK39",name:"Nina Harris",email:"ninasbooknook@gmail.com",role:"user"},
  {code:"SSDD-SBES90",name:"Selena Burke",email:"phoenyx.fyre.services@gmail.com",role:"user"},
  {code:"SSDD-AYPA86",name:"Alicia Young",email:"nox.haven.pa@gmail.com",role:"user"},
  {code:"SSDD-II5442",name:"Inkspire",email:"inkspire20254@gmail.com",role:"user"},
  {code:"SSDD-KMPA43",name:"Kelsie Munoz",email:"atouchofsmut.pa@gmail.com",role:"user"},
  {code:"SSDD-VTCT58",name:"Viktoriia Tomynets",email:"simplelookdesigncontact@gmail.com",role:"user"},
  {code:"SSDD-ARDS65",name:"Ashleigh Reeds",email:"theashleighreeds@gmail.com",role:"user"},
  {code:"SSDD-TRCO26",name:"Taysia Rogers",email:"culturedinkco@gmail.com",role:"user"},
  {code:"SSDD-WJTO30",name:"Windy Johnson",email:"windypaneto@gmail.com",role:"user"},
  {code:"SSDD-BLXX34",name:"Bobbi Lawson",email:"thesmuteditionxx@gmail.com",role:"user"},
  {code:"SSDD-JF2337",name:"Jamie Frazier",email:"jamie.frazier2023@gmail.com",role:"user"},
  {code:"SSDD-AANT69",name:"Aqsa",email:"thataestheticpoint@gmail.com",role:"user"},
  {code:"SSDD-KK1320",name:"Kate Kelly",email:"katedecidedtoread13@gmail.com",role:"user"},
  {code:"SSDD-AS1048",name:"Ali Shipley",email:"Mybookishcorner10@gmail.com",role:"user",duplicate:true},
  {code:"SSDD-THIE34",name:"Terecia Harris",email:"teathegnomie@gmail.com",role:"user"},
  {code:"SSDD-CLET29",name:"Crimson Lockhart",email:"terroronslashstreet@gmail.com",role:"user"},
  {code:"SSDD-CD9826",name:"Courtney Dawood",email:"cdawood1998@gmail.com",role:"user"},
  {code:"SSDD-CA0668",name:"Chloe Adcock",email:"cadcock06@icloud.com",role:"user",duplicate:true},
  {code:"SSDD-CA0664",name:"Chloe Adcock",email:"cadcock06@icloud.com",role:"user",duplicate:true},
  {code:"SSDD-AS1091",name:"Ali Shipley",email:"Mybookishcorner10@gmail.com",role:"user",duplicate:true},
  {code:"SSDD-AFLE78",name:"Ashley Frampton",email:"fallingdownthebookhole@gmail.com",role:"user"},
  {code:"SSDD-ADES93",name:"Adrianna Dianda",email:"adriannacrosswrites@yahoo.com",role:"user"},
  {code:"SSDD-KIPA16",name:"Kelsey Imberg",email:"bookedonafeelingpa@gmail.com",role:"user"},
  {code:"SSDD-TF0187",name:"Titilola Fasola",email:"lolabecca2001@gmail.com",role:"user"},
  {code:"SSDD-RTES94",name:"Rebekah Turnbull",email:"onceuponapaservices@gmail.com",role:"user",duplicate:true},
  {code:"SSDD-RTES66",name:"Rebekah Turnbull",email:"onceuponapaservices@gmail.com",role:"user",duplicate:true},
  {code:"SSDD-BOLF92",name:"Bryanna Olson",email:"bryannasbookshelf@gmail.com",role:"user"},
  {code:"SSDD-ASAD55",name:"Ananya Shahrazad",email:"ananya.shahrazad@gmail.com",role:"user"},
  {code:"SSDD-SSES64",name:"Siddhi",email:"silvaawrites@gmail.com",role:"user"},
  {code:"SSDD-SKUR33",name:"Simran Kaur",email:"authorsimrankaur@gmail.com",role:"user"},
];

/* ── THEME ── */
const darkT = {
  pageBg:"#0D1821", sideBg:"#09131E", panelBg:"#0F1E2E", cardBg:"#132030",
  deepBg:"#0A1620", text:"#EEE8E0", textMuted:"#4A6A80", textSub:"#8AA0BC",
  border:"#1E3248", gold:"#B89440", rose:"#C97060", teal:"#3A8A7A",
  inputBg:"#132030", inputBorder:"#1E3248", placeholder:"#3A556A",
  tabActive:"#B89440", tabInactive:"#4A6A80",
};
const lightT = {
  pageBg:"#F5F0EA", sideBg:"#EDE8DF", panelBg:"#E8E2D8", cardBg:"#FFFFFF",
  deepBg:"#F0EBE3", text:"#1A1A2E", textMuted:"#6A5A48", textSub:"#5A4A38",
  border:"#D4C9B8", gold:"#8A6820", rose:"#A04030", teal:"#2A6A5A",
  inputBg:"#FFFFFF", inputBorder:"#D4C9B8", placeholder:"#9A8A78",
  tabActive:"#8A6820", tabInactive:"#7A6A58",
};

let T = darkT;

const GS = (t) => `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;overflow:hidden;}
body{font-family:'Inter',sans-serif;background:${t.pageBg};color:${t.text};-webkit-text-size-adjust:100%;}
::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-track{background:${t.pageBg};}::-webkit-scrollbar-thumb{background:${t.gold}33;border-radius:3px;}
input,textarea,select{font-family:'Inter',sans-serif;background:${t.inputBg};border:1px solid ${t.inputBorder};color:${t.text};border-radius:6px;padding:8px 12px;font-size:13px;width:100%;outline:none;transition:border-color .18s;}
input:focus,textarea:focus,select:focus{border-color:${t.gold};}
input::placeholder,textarea::placeholder{color:${t.placeholder};}
select option{background:${t.inputBg};}
textarea{resize:vertical;min-height:80px;line-height:1.6;}
button{cursor:pointer;font-family:'Inter',sans-serif;}
@media(max-width:600px){input,textarea,select{font-size:16px;}}
`;

/* ── HELPERS ── */
const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2);
function genCode(){
  const c="ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; let r="SHELF-";
  for(let i=0;i<5;i++) r+=c[Math.floor(Math.random()*c.length)];
  return r;
}
function daysLeft(){ return Math.max(0,Math.ceil((new Date(GRACE_DEADLINE)-new Date())/(864e5))); }
function graceExpired(){ return new Date()>new Date(GRACE_DEADLINE); }
function lookupLegacy(c){ return LEGACY_USERS.find(u=>u.code.toUpperCase()===c.trim().toUpperCase()); }
function lookupNew(c){ try{ return JSON.parse(localStorage.getItem(CODES_KEY)||"[]").find(u=>u.code.toUpperCase()===c.trim().toUpperCase()); }catch(e){ return null; } }
// Scheduled expiry: a code may carry an `expires` date (YYYY-MM-DD). Access is
// blocked from the START of the day AFTER the expiry date, so "Access Until
// 2026-08-01" means the user keeps access through all of Aug 1 and is locked out
// on Aug 2. Blank/absent `expires` = never expires.
function codeExpired(u){
  if(!u||!u.expires) return false;
  const end=new Date(u.expires+"T23:59:59");
  return new Date()>end;
}
function expiryLabel(u){
  if(!u||!u.expires) return "";
  return codeExpired(u) ? ("Expired "+u.expires) : ("Until "+u.expires);
}
// Universal expiry store helpers — work for ANY code (legacy or generated).
function getExpiryMap(){ try{ return JSON.parse(localStorage.getItem(EXPIRY_KEY)||"{}"); }catch(e){ return {}; } }
function setExpiryFor(code,date){
  const m=getExpiryMap();
  if(date) m[code]=date; else delete m[code];
  localStorage.setItem(EXPIRY_KEY,JSON.stringify(m));
}
// Resolve a code's effective expiry: prefer the universal store, fall back to
// any `expires` stored on a generated code record.
function effectiveExpiry(code,fallback){
  const m=getExpiryMap();
  return m[code] || fallback || "";
}
function codeExpiredByCode(code,fallback){
  return codeExpired({expires:effectiveExpiry(code,fallback)});
}
function loadPP(cb){ if(window.paypal){cb();return;} const s=document.createElement("script"); s.src=`https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&vault=true&intent=subscription`; s.onload=cb; document.head.appendChild(s); }
async function sendEmail(to,name,code){ if(!to)return; await fetch("https://api.emailjs.com/api/v1.0/email/send",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({service_id:EMAILJS_SERVICE,template_id:EMAILJS_TEMPLATE,user_id:EMAILJS_KEY,template_params:{to_email:to,to_name:name||"there",access_code:code,app_url:window.location.href,unsubscribe_url:"https://www.paypal.com/myaccount/autopay/"}})}); }
async function sendNotif(to,name,code){ await fetch("https://api.emailjs.com/api/v1.0/email/send",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({service_id:EMAILJS_SERVICE,template_id:EMAILJS_TEMPLATE,user_id:EMAILJS_KEY,template_params:{to_email:NOTIFY_EMAIL,to_name:"Lisa",access_code:"NEW SUBSCRIBER\nName: "+(name||"Unknown")+"\nEmail: "+to+"\nCode: "+code,app_url:window.location.href,unsubscribe_url:"#"}})}); }

/* ── DATA ── */
const GENRES=["Romance","Dark Romance","Fantasy","Urban Fantasy","Paranormal Romance","Sci-Fi","Thriller","Psychological Thriller","Crime Thriller","Survival Thriller","Suspense","True Crime","Mystery","Cozy Mystery","Horror","Historical Fiction","Contemporary Fiction","Literary Fiction","Young Adult","New Adult","Middle Grade","Women's Fiction","Memoir","Self-Help","Romantasy","Gothic","Dystopian","Post-Apocalyptic","Steampunk","Time Travel","Magical Realism","Reverse Harem","Omegaverse","Erotica","Graphic Novel","Short Story Collection","Anthology","Chick Lit","Bromance"];
const FORMATS=["Hardcover","Paperback","Mass Market Paperback","eBook","Audiobook","ARC","Large Print","Box Set","Special Edition","Collectors Edition","Signed Edition","Kindle Unlimited","Serial","Wattpad"];
const ALL_TROPES=["Enemies to Lovers","Lovers to Enemies","Friends to Lovers","Rivals to Lovers","Enemies to Friends to Lovers","Hate to Love","Slow Burn","Fast Burn","Insta-Love","Love Triangle","Second Chance Romance","Reunited Lovers","Childhood Sweethearts","Forbidden Love","Star-Crossed Lovers","Unrequited Love","Mutual Pining","Forced Proximity","Stuck Together","Road Trip Romance","Fake Dating","Fake Engagement","Fake Marriage","Marriage of Convenience","Arranged Marriage","Contract Marriage","Secret Relationship","Hidden Identity","Secret Baby","Surprise Pregnancy","Co-Parenting","Single Parent","Grumpy/Sunshine","Alpha Hero","Omega Hero","Protective Hero","Possessive Hero","Obsessed MMC","Down Bad Hero","Touch-Starved Hero","He Falls First","She Falls First","Brooding Hero","Gentle Giant","Big Scary Man Is Actually Soft","Anti-Hero","Villain Love Interest","Morally Grey MMC","Morally Grey FMC","Competent FMC","Boss FMC","Chosen One","Boss/Employee","Office Romance","Forbidden Office Romance","Professor/Student","Doctor/Patient","Bodyguard Romance","Sports Romance","Rock Star Romance","Celebrity Romance","Royalty Romance","Billionaire Romance","CEO Romance","Mafia Romance","Dark Mafia","Military Romance","Firefighter Romance","Police Romance","Detective Romance","Cowboy Romance","Small Town Romance","Opposites Attract","Fated Mates","True Mates","Soulmates","Reverse Harem","Why Choose","Found Family","Vampire Romance","Werewolf Romance","Shifter Romance","Dragon Romance","Fae Romance","Demon Romance","God/Mortal Romance","Monster Romance","Immortal Falls for Human","Dual POV","Multiple POV","Unreliable Narrator","Dual Timeline","Epistolary","Redemption Arc","Dark Past","Trauma Recovery","Healing Together","Hurt/Comfort","Angst With Happy Ending","Grief Romance","Dark Academia","Gothic Romance","Mistaken Identity","Accidental Roommates","One Bed","Jealousy Arc","Surname Trope","Forehead Kiss","Temple Kiss","He Notices the Little Things","Quiet Acts of Service","She Wears His Clothes","Late Night Conversations","4AM Vulnerability","Touch Her and Die","Love Confession in the Rain","Airport Chase","I Choose You Every Time","Human Trafficking Thriller","Survival Horror","Captivity Thriller","Conspiracy Thriller","Missing Persons","Kidnapping","Escape Thriller"];
const GRAPHICS_TYPES=["Quote Graphic","Character Card","Release Announcement","ARC Call","Review Pull","Trope List","Mood Board","Cover Reveal","Countdown Graphic","Series Timeline","Character Aesthetic","Book Club Graphic","CW/TW List","Hashtag Bank Graphic","Promo Banner","Newsletter Header","Social Profile Banner","Story Slide","Carousel Slide","Pin Graphic"];
const HASHTAGS_ALL=["#BookTok","#Bookstagram","#BookRecommendations","#MustRead","#BookLovers","#ReadingCommunity","#Bookish","#BookNerd","#CurrentlyReading","#BookReview","#NewRelease","#BookAlert","#ReadMore","#FictionReads","#BookAddict","#RomanceReads","#RomanceBookTok","#RomanceCommunity","#HEA","#SmutTok","#RomanceNovels","#BookBoyfriend","#MMC","#FMC","#EnemiestoLovers","#SlowBurn","#ForcedProximity","#TropeTok","#DarkRomance","#SpicyBooks","#SpicyBookTok","#KindleUnlimited","#KindleBooks","#BookishContent","#Shelfie","#BookPhotography","#BookFlatlay","#BookCommunity","#BookBlogger","#BookInfluencer","#AuthorLife","#IndieAuthor","#SelfPublished","#WritersOfTikTok","#AuthorTikTok","#Bookstagrammer","#ReadersOfInstagram","#InstaBooks","#BookPhotographer","#Bibliophile","#FantasyBooks","#FantasyBookTok","#EpicFantasy","#UrbanFantasy","#FantasyReads","#RomantasyBooks","#RomantasyTok","#MagicBooks","#WorldBuilding","#FantasyCommunity","#ThrillerBooks","#CrimeFiction","#MysteryBooks","#SuspenseTok","#ThrillerReads","#PageTurner","#CantPutItDown","#OneMoreChapter","#BookHangover","#ReadingSlump","#CozyRead","#CozyBookTok","#CozyMystery","#CozyFantasy","#CozyRomance","#YABooks","#YABookTok","#YoungAdult","#YAFiction","#YAFantasy","#ARC","#ARCReview","#NetGalley","#Edelweiss","#AdvancedReaderCopy","#SeriesBooks","#BookSeries","#WhyChoose","#ReverseHarem","#Omegaverse","#HistoricalFiction","#HistoricalRomance","#RegencyRomance","#ParanormalRomance","#VampireRomance","#WerewolfRomance","#FaeRomance","#ShifterRomance","#MafiaRomance","#DarkMMC","#ObsessedMMC","#BookQuotes","#QuoteOfTheDay","#5StarRead","#BookHype","#BookRating","#ReadingGoals","#BookClub","#TruecrimeBookTok","#ThrillerReaders","#CrimeThriller"];
const TIKTOK_CONCEPTS=["Book-to-playlist: songs that match each chapter","Trope check with text overlays and tick marks","Meet the MMC: character introduction reel","Meet the FMC: personality breakdown reel","The tension-o-meter: rating tension chapter by chapter","Spicy-o-meter: rating scenes 1-5","Reading vlog: first reaction while reading live","This scene had me-- reaction reel","Books that ruined me featuring this one","If you liked [comp], read THIS","First chapter reading aloud in aesthetic setting","Annotating the book live","ARC reader reactions compilation","One quote per chapter video","Character moodboard reel","Trope bingo card filled out","Behind the scenes: the author writing a scene","POV: you just discovered [title]","Red flags vs green flags in the MMC","Enemies to lovers timeline","The slow burn broken down","Day in the life of [character]","Before vs after finishing this book","What this book did to me","Reading order guide for series or backlist","Why BookTok is obsessed: breaking down the hype","Physical book tour: special edition details","Three words to describe this book challenge","Duet with another reader's reaction","Respond to: sell me this book in 30 seconds","The moment I knew I was obsessed","Things this book does that others refuse to","Author talks about hardest scene to write","What inspired this book: origin story reel","Fan casting the characters","Cover design breakdown: what each element means","Typing out the best quotes over b-roll","Searching book on Goodreads for the first time","Speed run: summarizing the book in 60 seconds","Author explains foreshadowing you missed"];
const TIKTOK_BROLL=["Hands turning pages slowly in soft window light","Coffee or tea steaming next to the book","Rain on a window with book in soft focus foreground","Bookshelf pan with this book visible","Candles lit around the book on dark surface","Walking through a library or bookstore holding the book","Flatlay of the book with flowers and aesthetic props","Close-up of highlighted or annotated pages","Sticky notes and tabs sticking out of the book","Book spine close-up while pulling off shelf","Hand writing in margins or on sticky notes","Book next to a window with natural bokeh","Stacking multiple books with this one on top","Holding the book against a seasonal outdoor background","Fireplace or fairy lights blurred in background","Close-up of cover art with slow zoom or pan","Reading in a cozy chair wrapped in a blanket","Book on a cafe table with latte art in frame","Sunlight falling across the open pages","Closing the book dramatically","Hands holding book open showing typography inside","Book next to matching color-coordinated props","Slow flip through pages showing edge color","Outdoor reading: park bench, hammock, porch swing","Night reading: bedside lamp, cozy pillows, book in hand"];
const TIKTOK_FORMATS=["Text POV: white text on black background","Trending audio: lip sync with book quotes as overlay","Before/After: how I was vs how I am after this book","Things that are the same energy as [character]","Get ready with me while I talk about this book","Day in the life of someone who just finished","Storytime: what this book did to me","Ranking chapters or scenes by chaos level","Stitching another creator's reaction","Green screen with book cover while talking","Duet with author reading a quote","Hot take: unpopular opinion about this genre","This or that: character edition","Would you rather: scenes from the book","Tell me you read dark romance without telling me","ASMR page turning with quote text appearing","Typing simulator: typing out the best quote dramatically","Speed run: summarizing the book in 60 seconds","Trend hijack: using a non-book trend to promote","Reply to comment: answering what should I read next","Things I learned from this book trending format","React to your own annotations","Author explains foreshadowing you missed","Searching the book on Goodreads for the first time","Rate your recent reads trending template"];
const TIKTOK_OVERLAYS=["When the MMC finally breaks","She did not know he was watching","The slow burn was worth it","This scene lives in my head rent-free","He noticed first","She had no idea","The moment everything changed","Before they admitted it","The tension in this scene needs its own ZIP code","Sir there was no reason to say that","He knew exactly what he was doing","She fumbled. He smiled.","This is what enemies to lovers actually looks like","The yearning is criminal","I am not okay and that is the review","The chemistry started on page one","He fell first and he fell HARD","No one is immune to this man","The flags are neon green","This conversation changed everything","The moment she realised","The moment he realised he was already gone","The eye contact alone could power a city","They cannot be left unsupervised","This chapter had me giggling and kicking my feet","One bed. Two people with terrible communication.","Touch her and find out","She changed him and she did not even try","The emotional damage in this scene is insane","Your honour, he was cooked","Warning: this chapter contains feelings","I was not prepared and I should have been","Everything is fine. He just touched her hand.","She is the main character of his life and she has no idea","She did not ask for any of this. He gave it anyway."];
const HOOK_BANKS={
  curiosity:["If you love a [character trait] lead...","The [element] hiding inside this scene is criminal","The moment the [character] becomes completely obsessed with [person]","Nothing hits like an unexpected [scene]","POV: a [genre] for readers who love [element]","No because WHY did [he/she] say that","The scene that survived every draft","I was NOT prepared","This book has no right to be this good","What if I told you there was a book where [premise]","Not a drill: [trope/element] done RIGHT","The [element] payoff in this book... I am not normal","How does one book have THIS much tension","Nothing will prepare you for chapter [X]","Warning: will cause involuntary re-reads","The first chapter alone had me committed","Signs you are about to lose sleep over a fictional character","POV: you just found your next 5-star read","I highlighted more pages than I didn't","This book was recommended to me and I will never forgive them"],
  emotional:["I opened this book for fun. Now I am emotionally wrecked.","I fear this scene permanently altered my brain chemistry","This book broke me and I am giving it 5 stars","I did not consent to these feelings","Some books change you. This is one of them.","I finished this and immediately started over","For everyone who reads to feel less alone","The ending had me staring at the ceiling for an hour","The kind of book you mourn when it is over","Worth. The. Wait.","I ugly cried and I have no regrets","Finished this at 3am and felt personally attacked","The healing arc in this one... I am not okay","I fear I will be recommending this book for years","No one warned me about that chapter and that is rude","The way this book lived in my head for days after","I finished this and immediately texted everyone I know","I thought I knew where this was going. I did not.","Some scenes need their own trigger warning for feelings","The kind of love story that recalibrates your standards"],
  character:["Everyone wanted [him/her]. [He/She] only wanted [her/him].","This [man/woman] is DOWN BAD","He falls first and he falls HARD","The MMC in this book is scientifically engineered to ruin you","He is terrifying to everyone except her","He noticed the little things before he admitted he liked her","She has no idea how much he is paying attention","He is the kind of man who would rearrange his whole life quietly","She fumbled. He smiled. Unfortunately for him, he liked it.","He acts unbothered. He is not unbothered.","She has absolutely no idea she is the main character of his life","The [character] love language is [thing]","God forbid the [character] is [trait]","The [character] is not beating the [trait] allegations","Writing characters who are [trait] is my favourite hobby","One [description]. One [character] who can't stop [action].","She asked for nothing. He decided to give her everything anyway.","He is not trying to be smooth. He is just sincere. Worse.","She did not ask for any of this and she handled it with chaos","He does not smile for anyone else and the whole room has noticed"],
  pov:["POV: one more chapter","POV: you just found your next 5-star read","POV: you are on page 1 and already know you are in trouble","POV: you told yourself just one chapter","POV: it is 3am and you are emotionally compromised","POV: you just got to the chapter everyone warned you about","POV: you just finished and have to tell everyone immediately","POV: you just discovered your new comfort read","POV: you read the first page and your whole day is cancelled","The scream I scrumpt","This chapter had me saying OH every five seconds","This chapter had me grinning like an idiot","This scene called me single and I did not appreciate it","Not me giggling over fictional people again","I did not expect that scene to be my favourite","I highlighted this immediately","The way they are each other's favourite person","Oh they're flirting flirting","This chapter had me kicking my feet over [element]","I folded immediately"],
  teaser:["This is what [trope] actually looks like","For the readers who love [element]","If [element] is your love language, this book is for you","Warning: this book includes [element]","This is your sign to read a [genre] with [element]","The [trope] trope remains undefeated","If [trope] payoffs are your thing...","[Trope] enjoyers, we won","This scene is for everyone whose love language is [element]","Men written by women >>>","Romance readers will see this and say hell yeah","This is why romance readers have standards","In their [era] era","Unfortunately, [element] is my kink","[Trope] readers, this is for you","For everyone who has been waiting for the perfect [trope] book","This one goes out to the slow burn survivors","A love story for people who think they don't believe in love stories","For everyone who re-reads [trope] books like a ritual","A reminder that fiction can absolutely ruin you in the best way"],
  fear:["The kind of book you read with the lights on","The scene that made me look over my shoulder","I had to put this down and take a breath","This book will make you afraid of [thing]","The tension in this scene could power a city","I did not expect to be THIS scared","The kind of thriller that follows you home","She made a decision and I screamed at the page","The dread in this book is next level","This author understands exactly how fear works"],
  viral:["The [element] in this book broke BookTok and here's why","Everyone is talking about [title] because of THIS scene","The chapter that has readers losing their minds","This is the scene BookTok cannot stop screenshotting","Not okay. Not fine. Cannot stop thinking about this.","The [trope] that has the entire community in a chokehold","This book went viral for a reason. Let me show you.","I see why this is ALL over BookTok","The scene everyone is quoting right now","This is that book. You know the one."],
  scroll:["Stop scrolling. Read this instead.","The book description that made me immediately one-click","Three words: [word]. [word]. [word].","I need you to understand how good this book is","Close your eyes. Imagine [scenario]. That's this book.","The blurb didn't prepare me. Let me prepare you.","Everything about this book is designed to ruin you","This author sat down and chose violence","I am begging you to read this book","Your next read is right here and I will not apologize"],
  pitch:["[Title]: [one-sentence hook]","[Character] thought [assumption]. Then [twist].","In a world where [premise], one [character] must [stakes].","[Title] is [comp1] meets [comp2] for readers who love [trope].","When [inciting incident], [character] discovers [truth] — and nothing will ever be the same.","[Title]: a [genre] about [theme] wrapped in [setting].","The story of [character] who [quest] — and the [obstacle] standing in their way.","For readers who love [comp author], [Title] delivers [promise].","[Title] — where [world] meets [heart].","[Character]. [Setting]. [Stakes]. [Title]."],
  comment:["Team [Character A] or Team [Character B]? Be honest.","Rate this book in one emoji. Go.","What scene broke you? (No spoilers, just vibes)","One word to describe this book: GO","The way this book made you feel: describe it with a gif","Did you see the ending coming? Yes/No/Sort of?","If this book was a playlist, what is the first song?","What character would you trust with your life?","What trope does this book absolutely nail?","Would you reread this? And how many times?"],
};
const CAPTION_IDEAS={
  release:["IT IS RELEASE DAY and I am not calm about it. [Title] is officially in the world and [author] delivered everything I hoped for and then some.","The day is finally here. [Title] by [author] is out NOW and if you have been waiting for your next obsession, this is it.","Release day for [Title] and my emotions are a lot. This book is [one word]. Pick it up, come back, and let's talk about THAT scene.","It is giving [vibe]. It is giving [trope]. It is [Title] by [author] and it just dropped.","The wait is over. [Title] is here. If you love [trope] and [trope] served with [element], this is the book you have been looking for.","Happy release day to [Title] -- a book that genuinely wrecked me in the best possible way.","Today [author] releases [Title] and the [genre] community is eating well."],
  review:["If you have read [Title], I need to know what you thought about [specific scene]. Drop a star rating in the comments.","Calling all readers of [Title] -- have you recovered yet? Because I have not.","Your reviews for [Title] mean everything to [author] right now. If you loved it, a quick rating goes a long way.","If [Title] has landed in your hands this week, I would love to know your first impressions. No spoilers, just vibes.","Review request: if [Title] has already destroyed you emotionally, leave a quick review and warn others. Or recruit them."],
  reaction:["The messages I have been getting about [Title] are everything. You all are not okay and neither am I.","The BookTok community found [Title] and now we are all going through it together. This is fine.","I have been collecting your reactions to [Title] and they are making me emotional.","Seeing readers discover [Title] in real time is one of my favourite things.","The readthrough is in full swing and the [trope] moment? It wrecked them."],
  haveyouread:["Have you read [Title] yet? Because if not, here is why you should stop what you are doing and start immediately.","If [Title] has not been on your radar yet, consider this your sign.","Not enough people are talking about [Title] and I am making it my mission to fix that.","The [Title] hype is real and I need more people in on it. Here is the 30-second pitch.","Still thinking about [Title] [X] days later. If you haven't read it yet, here is what happens when you do."],
  cover:["The cover for [Title] just broke my brain a little. Look at this. LOOK AT IT.","Cover reveal day for [Title] and it is giving exactly the [mood] I was hoping for.","She is HERE. The cover for [Title] has officially been revealed and I am obsessed.","Happy cover reveal to [Title] which is clearly going to be a problem for my self-control when it releases.","I have been waiting to share this cover and I cannot believe it is finally happening. [Title] by [author]."],
};
const SOURCE_LIB={Romance:["Smart Bitches Trashy Books","Heroes and Heartbreakers","Dear Author","All About Romance","The Ripped Bodice Blog","BookTok RomanceBookTok","Goodreads Romance Listopia","NetGalley","Edelweiss Plus"],Fantasy:["Tor.com","Fantasy Literature","Grimdark Magazine","Fantasy Book Critic","Book Riot Fantasy"],"Sci-Fi":["Locus Magazine","SF Signal","Nerds of a Feather","Tor.com"],Thriller:["Crime Fiction Lover","Mystery Scene Magazine","Book Reporter Thriller","The Suspense Magazine"],Mystery:["Stop You're Killing Me","Cozy Mystery List","Deadly Pleasures"],Horror:["This Is Horror","Hellnotes","Cemetery Dance"],"Historical Fiction":["Historical Novel Society","Reading the Past"],"Young Adult":["YA Books Central","Forever YA"],General:["Book Riot","NetGalley","Edelweiss Plus","BookTok","Goodreads Listopia","Paste Magazine Books"]};

/* ── BLANK FACTORIES ── */
const blankChar = () => ({id:uid(),name:"",role:"",archetype:"",personality:"",desc:"",backstory:"",strengths:"",weaknesses:"",reader_appeal:"",content_angles:"",intro:"",moodboard:"",postideas:""});
const blankReview = () => ({id:uid(),reviewer:"",type:"Reader",excerpt:"",link:"",platform:"",stars:"5"});
const blankGraphic = () => ({id:uid(),type:"Quote Graphic",file:null,fileName:"",notes:""});
const blankAuthorLink = () => ({id:uid(),type:"Website",url:"",label:""});
const blankBook = () => ({
  id:uid(), title:"", subtitle:"", series:"", seriesNum:"", publishDate:"", format:"", isbn:"", publisher:"", asin:"", page_count:"", word_count:"", status:"Draft",
  genres:[], subgenres:[], coverPhoto:null, coverPhotoName:"", bookFile:null, bookFileName:"",
  surface_story:"", deeper_story:"", themes:"", book_dna:"", book_dna_notes:"", reader_audience:"", comp_authors:"", comp_books:"", genre_selling:"",
  pitch_one_sentence:"", pitch_short:"", pitch_agent:"", pitch_publisher:"", pitch_bookstore:"", pitch_book_club:"", pitch_social:"",
  hooks_curiosity:"", hooks_emotional:"", hooks_character:"", hooks_pov:"", hooks_teaser:"", hooks_fear:"", hooks_viral:"", hooks_scroll:"", hooks_pitch:"", hooks_comment:"",
  quotes:[], tropes:[], hidden_tropes:"", char_dynamics:"", rel_dynamics:"",
  characters:[blankChar()],
  mkt_usp:"", mkt_why:"", mkt_promise:"", mkt_payoff:"", mkt_who:"", mkt_comps:"", mkt_selling:"", mkt_genre_selling:"",
  cap_release:"", cap_review:"", cap_reaction:"", cap_haveyouread:"", cap_cover:"",
  tiktok_ideas:"", tiktok_broll:"", tiktok_formats:"", tiktok_overlays:"", tiktok_content_pillars:"",
  graphics:[], graphics_canva:"", graphics_aesthetic:"",
  discuss_bookclub:"", discuss_engagement:"", discuss_polls:"", discuss_prompts:"",
  hashtags_selected:[], hashtags_custom:"",
  reviews:[],
  influencer_thriller:"", influencer_truecrime:"", influencer_womens:"", influencer_bookclub:"", influencer_outreach:"",
  collab_bookstores:"", collab_podcasts:"", collab_libraries:"",
  bonus_moments:"", bonus_quotes:"", bonus_relatable:"", bonus_emotional:"", bonus_graphics:"", bonus_arcs:"", bonus_scenes:"", bonus_lines:"",
  notes:"", research_links:[],
});
const blankAuthor = () => ({id:uid(), name:"", email:"", phone:"", photo:null, tiktok:"", instagram:"", goodreads:"", amazon:"", website:"", facebook:"", threads:"", youtube:"", newsletter:"", linktree:"", notes:"", links:[], books:[blankBook()]});

/* ── EXPORT ── */
function exportText(author, book, preparer){
  try{
  preparer = preparer || {};
  const prepName    = preparer.name || "";
  const prepBusiness= preparer.business || "";
  const prepEmail   = preparer.email || "";
  const prepWebsite = preparer.website || "";
  const prepTiktok  = preparer.tiktok || "";
  const prepInsta   = preparer.instagram || "";

  // Color theme — the PAGE stays a clean, light, printable document at all times.
  // Only the ACCENTS change per book to match its cover. Authors set accent / accent2;
  // everything else (page, cards, text, borders) is locked to a warm light scheme.
  const theme = book.exportTheme || {};
  const ACCENT  = theme.accent  || "#8B6F47";   // primary book accent (headings, rules, labels)
  const ACCENT2 = theme.accent2 || ACCENT;      // secondary accent (falls back to primary)
  const PAGE    = "#FFFFFF";   // clean white page (no visible box edge)  (fixed)
  const CARD    = "#F6F3ED";   // soft cream card                          (fixed)
  const HEAD    = "#1C1A17";   // near-black heading         (fixed)
  const BODY    = "#33302B";   // warm dark body text        (fixed)
  const SUB     = "#7A736A";   // muted warm label           (fixed)
  const BORDER  = "#E3DCD0";   // soft warm border           (fixed)
  // A very light tint of the accent, for subtle fills behind labels/quotes.
  const accentTint = (theme.accent || "#8B6F47") + "12";

  const esc = s => s ? String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;") : "";
  const nl  = s => esc(s).replace(/\n/g,"<br/>");

  const field = (label, val) => {
    if(!val || !String(val).trim()) return "";
    return `<div class="field">
      <div class="flabel">${esc(label)}</div>
      <div class="fval">${nl(val)}</div>
    </div>`;
  };

  const twoCol = (a, b) => (a||b) ? `<div class="two-col"><div>${a||""}</div><div>${b||""}</div></div>` : "";

  const section = (title, body, accent) => {
    if(!body || !body.trim()) return "";
    const a = accent || ACCENT;
    return `<div class="sec">
      <div class="sec-head" style="color:${a};border-bottom:2px solid ${a}22;">${esc(title)}</div>
      <div class="sec-body">${body}</div>
    </div>`;
  };

  // HOOKS
  const hookCats = [
    ["Curiosity Hooks",book.hooks_curiosity,ACCENT],
    ["Emotional Hooks",book.hooks_emotional,ACCENT],
    ["Character Hooks",book.hooks_character,ACCENT],
    ["POV Hooks",book.hooks_pov,ACCENT],
    ["Teaser Hooks",book.hooks_teaser,ACCENT],
    ["Fear / Tension Hooks",book.hooks_fear,ACCENT],
    ["Viral BookTok Hooks",book.hooks_viral,ACCENT2],
    ["Scroll-Stopping Hooks",book.hooks_scroll,ACCENT2],
    ["One-Sentence Pitch Hooks",book.hooks_pitch,ACCENT2],
    ["Comment-Bait Hooks",book.hooks_comment,ACCENT2],
  ];
  const hooksHtml = hookCats.filter(([,v])=>v&&v.trim()).map(([label,val,a])=>`
    <div class="hook-cat">
      <div class="hook-cat-label" style="color:${a}">${esc(label)}</div>
      ${val.split("\n").filter(l=>l.trim()).map(l=>`<div class="hook-item"><span style="color:${a};margin-right:6px;">&#9656;</span>${esc(l.trim())}</div>`).join("")}
    </div>`).join("");

  // QUOTES
  const typeColors = {Powerful:ACCENT,Romantic:ACCENT2,Emotional:ACCENT,Funny:"#7A6A4A",Fear:"#8A5A5A","Best for Graphics":ACCENT2,Tension:"#8A5A5A",Horror:"#8A5A5A"};
  const quotesHtml = (book.quotes||[]).filter(q=>q.text).map(q=>{
    const a = typeColors[q.type] || ACCENT;
    return `<div class="quote-card" style="border-top:3px solid ${a}22;border-left:3px solid ${a};">
      <div class="q-type" style="color:${a}">${esc(q.type||"Quote")}${q.chapter?` &bull; Ch.${esc(q.chapter)}`:""}${q.pg?` p.${esc(q.pg)}`:""}</div>
      <div class="q-text">&ldquo;${esc(q.text)}&rdquo;</div>
      ${q.notes?`<div class="q-notes">${esc(q.notes)}</div>`:""}
    </div>`;
  }).join("");

  // PLAYLIST
  const playlistSongs = (book.playlist||[]).filter(s=>s&&(s.title||s.artist));
  const playlistHtml = playlistSongs.map((s,i)=>`
    <div class="song-row">
      <div class="song-num" style="color:${ACCENT2}">${String(i+1).padStart(2,"0")}</div>
      <div class="song-main">
        <div class="song-title">${esc(s.title||"")}</div>
        ${s.artist?`<div class="song-artist">${esc(s.artist)}</div>`:""}
      </div>
      ${s.note?`<div class="song-note">${esc(s.note)}</div>`:""}
    </div>`).join("");

  // CHARACTERS
  const charsHtml = (book.characters||[]).filter(c=>c.name).map(c=>`
    <div class="char-card">
      <div class="char-head">
        <div class="char-name" style="color:${ACCENT}">${esc(c.name)}</div>
        <div class="char-role">${esc(c.role||"")}${c.archetype?` &mdash; ${esc(c.archetype)}`:""}</div>
      </div>
      ${c.intro?`<div class="char-intro" style="border-left:3px solid ${ACCENT};color:${SUB}">${esc(c.intro)}</div>`:""}
      ${c.desc?field("Description",c.desc):""}
      ${c.backstory?field("Backstory",c.backstory):""}
      ${c.personality?field("Personality",c.personality):""}
      ${twoCol(c.strengths?field("Strengths",c.strengths):"",c.weaknesses?field("Weaknesses",c.weaknesses):"")}
      ${c.reader_appeal?field("Reader Appeal",c.reader_appeal):""}
      ${c.content_angles?field("Content Angles",c.content_angles):""}
      ${c.postideas?field("Post Ideas",c.postideas):""}
    </div>`).join("");

  // BONUS
  const bonusSecs = [
    ["Top 10 Most Marketable Moments",book.bonus_moments],
    ["Top 10 Scream-Worthy Quotes",book.bonus_quotes],
    ["Top 10 Most Relatable Moments",book.bonus_relatable],
    ["Top 10 Most Emotional Scenes",book.bonus_emotional],
    ["Top 10 Best Lines for Graphics",book.bonus_graphics],
    ["Top 10 Best Character Arc Moments",book.bonus_arcs],
    ["Top 10 Scenes Most Likely to Go Viral",book.bonus_scenes],
    ["Top 10 Lines That Hit Harder on Reread",book.bonus_lines],
  ];
  const bonusHtml = bonusSecs.filter(([,v])=>v&&v.trim()).map(([label,val])=>`
    <div class="bonus-sec">
      <div class="bonus-label" style="color:${ACCENT}">${esc(label)}</div>
      ${val.split("\n").filter(l=>l.trim()).map((l,i)=>`<div class="bonus-item"><span class="bonus-num" style="color:${ACCENT}">${i+1 <= 10 && /^\d+\./.test(l.trim()) ? "" : `${i+1}.`}</span>${esc(l.trim().replace(/^\d+\.\s*/,""))}</div>`).join("")}
    </div>`).join("");

  const genreStr = (book.genres||[]).join(", ");
  const hashStr  = (book.hashtags_selected||[]).join(" ");
  const tropeStr = (book.tropes||[]).join(" &bull; ");

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<title>Content Pull &mdash; ${esc(book.title||"Book")}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}

/* PRINTED PAGE MARGINS — this is what controls the white space around the page
   in the saved PDF. Generous on all sides; footer line sits in the bottom margin. */
@page{
  size:Letter;
  margin:20mm 18mm 18mm 18mm;
}
@page{
  @bottom-center{
    content:"${esc((book.title||"Content Pull"))} \\2014 Content Pull Package  \\00b7  Prepared by ${esc(prepName||author.name||"")}  \\00b7  Page " counter(page);
    font-family:'Inter',sans-serif;font-size:8px;letter-spacing:0.04em;color:${SUB};
  }
}

body{background:${PAGE};color:${BODY};font-family:'Inter',sans-serif;font-size:13px;line-height:1.8;-webkit-print-color-adjust:exact;print-color-adjust:exact;}

/* On screen we center a comfortable column; in print @page owns the margins
   so the content fills the printable area edge to edge. */
.page{max-width:880px;margin:0 auto;padding:48px 56px;}
@media print{
  .page{max-width:none;margin:0;padding:0;}
  /* paint the page background into the @page margin area so there are no
     white strips around a dark theme */
  html,body{background:${PAGE};}
}

/* PRINT BAR */
.print-bar{position:fixed;top:0;left:0;right:0;background:#fff;border-bottom:1px solid ${BORDER};padding:10px 24px;display:flex;justify-content:space-between;align-items:center;z-index:999;gap:12px;flex-wrap:wrap;}
.print-btn{background:${ACCENT};color:#fff;border:none;border-radius:5px;padding:7px 18px;font-size:12px;font-weight:600;cursor:pointer;font-family:'Inter',sans-serif;letter-spacing:0.03em;}
.print-info{font-size:11px;color:${SUB};}
.print-spacer{height:52px;}
@media print{.print-bar,.print-spacer{display:none!important;}.pb{page-break-before:always;}}

/* HEADER */
.doc-header{display:flex;justify-content:space-between;align-items:flex-end;padding-bottom:20px;border-bottom:1px solid ${BORDER};margin-bottom:36px;}
.logo{font-family:'Cormorant Garamond',serif;font-size:22px;color:${HEAD};font-weight:600;}
.logo span{color:${ACCENT};}
.logo-sub{font-size:9px;letter-spacing:0.15em;text-transform:uppercase;color:${SUB};margin-top:2px;}
.doc-meta{text-align:right;font-size:11px;color:${SUB};line-height:1.55;}
.prep-label{font-size:8.5px;letter-spacing:0.16em;text-transform:uppercase;color:${SUB};}
.prep-name{font-family:'Cormorant Garamond',serif;font-size:15px;font-weight:600;color:${HEAD};line-height:1.2;}
.prep-biz{font-size:10.5px;color:${ACCENT};font-weight:500;margin-top:1px;}
.prep-links{font-size:9.5px;color:${SUB};margin-top:4px;max-width:280px;}
.prep-date{font-size:10px;color:${SUB};margin-top:5px;}

/* COVER */
.cover{display:grid;grid-template-columns:180px 1fr;gap:32px;align-items:start;padding:28px 32px;background:${CARD};border-radius:10px;border:1px solid ${BORDER};margin-bottom:36px;}
.cover-img{width:180px;height:270px;object-fit:cover;border-radius:5px;border:1px solid ${BORDER};display:block;}
.cover-placeholder{width:180px;height:270px;background:${PAGE};border-radius:5px;border:1px dashed ${BORDER};display:flex;align-items:center;justify-content:center;font-size:10px;color:${BORDER};text-transform:uppercase;letter-spacing:0.1em;}
.cover-tag{font-size:9px;font-weight:600;letter-spacing:0.18em;text-transform:uppercase;color:${ACCENT};margin-bottom:10px;}
.cover-title{font-family:'Cormorant Garamond',serif;font-size:32px;font-weight:700;color:${HEAD};line-height:1.15;margin-bottom:4px;}
.cover-by{font-size:13px;color:${SUB};font-style:italic;margin-bottom:16px;}
.cover-badges{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:20px;}
.badge{background:${PAGE};border:1px solid ${BORDER};border-radius:3px;padding:3px 9px;font-size:10px;color:${SUB};letter-spacing:0.02em;}
.cover-divider{border:none;border-top:1px solid ${BORDER};margin:16px 0;}
.contact-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;}
.contact-item .clabel{font-size:8.5px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:${ACCENT};display:block;margin-bottom:1px;}
.contact-item .cval{font-size:11px;color:${BODY};}

/* SECTIONS */
.sec{margin-bottom:32px;}
.sec-head{font-family:'Cormorant Garamond',serif;font-size:14px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;padding-bottom:8px;margin-bottom:16px;}
.sec-body{}

/* FIELDS */
.field{margin-bottom:16px;}
.field:last-child{margin-bottom:0;}
.flabel{font-size:8.5px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:${SUB};margin-bottom:5px;}
.fval{color:${BODY};line-height:1.8;font-size:13px;}
.two-col{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:16px;}

/* HOOKS */
.hook-cat{margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid ${BORDER};}
.hook-cat:last-child{border-bottom:none;margin-bottom:0;}
.hook-cat-label{font-size:9px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;margin-bottom:8px;}
.hook-item{font-size:12.5px;color:${BODY};padding:3px 0;line-height:1.7;}

/* QUOTES */
.quotes-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
.quote-card{padding:12px 14px;border-radius:5px;background:${CARD};break-inside:avoid;}
.q-type{font-size:8.5px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;margin-bottom:7px;}
.q-text{font-family:'Cormorant Garamond',serif;font-size:15px;color:${HEAD};line-height:1.65;font-style:italic;}
.q-notes{font-size:10px;color:${SUB};margin-top:7px;padding-top:6px;border-top:1px solid ${BORDER};}

/* PLAYLIST */
.playlist{display:flex;flex-direction:column;margin-top:8px;}
.song-row{display:grid;grid-template-columns:28px 1fr auto;gap:12px;align-items:baseline;padding:8px 0;border-bottom:1px solid ${BORDER};break-inside:avoid;}
.song-row:last-child{border-bottom:none;}
.song-num{font-family:'Cormorant Garamond',serif;font-size:14px;font-weight:700;text-align:right;}
.song-title{font-size:12.5px;font-weight:600;color:${HEAD};line-height:1.4;}
.song-artist{font-size:11px;color:${SUB};margin-top:1px;}
.song-note{font-size:10px;color:${SUB};font-style:italic;text-align:right;max-width:50%;line-height:1.5;}

/* CHARACTERS */
.char-card{background:${CARD};border-radius:8px;padding:20px 22px;margin-bottom:16px;border:1px solid ${BORDER};break-inside:avoid;}
.char-head{margin-bottom:14px;padding-bottom:12px;border-bottom:1px solid ${BORDER};}
.char-name{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:700;line-height:1.2;}
.char-role{font-size:11px;color:${SUB};font-style:italic;margin-top:2px;}
.char-intro{font-size:12px;padding:10px 14px;border-radius:4px;background:${PAGE};margin-bottom:14px;font-style:italic;line-height:1.7;}

/* TROPES */
.trope-pills{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px;}
.trope-pill{border-radius:20px;padding:3px 11px;font-size:10px;border:1px solid ${ACCENT}44;color:${ACCENT};background:${ACCENT}08;}

/* HASHTAGS */
.hash-wrap{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px;}
.hash-pill{border:1px solid ${BORDER};border-radius:3px;padding:2px 8px;font-size:10px;color:${SUB};background:${CARD};}

/* BONUS */
.bonus-sec{margin-bottom:22px;padding-bottom:22px;border-bottom:1px solid ${BORDER};}
.bonus-sec:last-child{border-bottom:none;}
.bonus-label{font-size:9px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:10px;}
.bonus-item{font-size:12.5px;color:${BODY};padding:5px 0;border-bottom:1px solid ${BORDER}22;line-height:1.65;display:flex;gap:10px;}
.bonus-num{color:${ACCENT};font-weight:600;min-width:20px;flex-shrink:0;}

/* FOOTER */
.doc-footer{margin-top:48px;padding-top:16px;border-top:1px solid ${BORDER};display:flex;justify-content:space-between;font-size:10px;color:${SUB};}
@media print{.doc-footer{display:none!important;}}
</style>
</head>
<body>

<!-- PRINT BAR (hidden on print) -->
<div class="print-bar">
  <div class="print-info">
    <strong style="color:${HEAD}">${esc(book.title||"Content Pull")}</strong>
    &mdash; Ready to export. Click Save as PDF, then in the print dialog choose <strong>Save as PDF</strong> and enable <strong>Background graphics</strong>.
  </div>
  <button class="print-btn" onclick="window.print()">&#8595; Save as PDF</button>
</div>
<div class="print-spacer"></div>

<div class="page">

<!-- DOC HEADER -->
<div class="doc-header">
  <div>
    <div class="logo"><span>Content</span>Sync</div>
    <div class="logo-sub">Book Content Pull Package</div>
  </div>
  <div class="doc-meta">
    <div class="prep-label">Prepared by</div>
    <div class="prep-name">${esc(prepName||author.name||"")}</div>
    ${prepBusiness?`<div class="prep-biz">${esc(prepBusiness)}</div>`:""}
    ${(prepEmail||prepWebsite||prepTiktok||prepInsta)?`<div class="prep-links">${[
      prepEmail?esc(prepEmail):"",
      prepWebsite?esc(prepWebsite):"",
      prepTiktok?esc(prepTiktok):"",
      prepInsta?esc(prepInsta):"",
    ].filter(Boolean).join(" &nbsp;&middot;&nbsp; ")}</div>`:""}
    <div class="prep-date">${new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</div>
  </div>
</div>

<!-- COVER -->
<div class="cover">
  ${book.coverPhoto
    ? `<img class="cover-img" src="${book.coverPhoto}" alt="${esc(book.title||"")} cover"/>`
    : `<div class="cover-placeholder">Book Cover</div>`}
  <div>
    <div class="cover-tag">Content Pull Package</div>
    <div class="cover-title">${esc(book.title||"Untitled")}</div>
    ${book.subtitle?`<div style="font-size:15px;color:${SUB};font-style:italic;margin-bottom:4px;">${esc(book.subtitle)}</div>`:""}
    <div class="cover-by">by ${esc(author.name||"Unknown Author")}</div>
    <div class="cover-badges">
      ${genreStr?`<span class="badge">${esc(genreStr)}</span>`:""}
      ${book.series?`<span class="badge">${esc(book.series)}${book.seriesNum?" #"+book.seriesNum:""}</span>`:""}
      ${book.format?`<span class="badge">${esc(book.format)}</span>`:""}
      ${book.publishDate?`<span class="badge">${esc(book.publishDate)}</span>`:""}
      ${book.page_count?`<span class="badge">${esc(book.page_count)} pages</span>`:""}
      ${book.word_count?`<span class="badge">${esc(book.word_count)} words</span>`:""}
      ${book.isbn?`<span class="badge">ISBN ${esc(book.isbn)}</span>`:""}
      ${book.asin?`<span class="badge">ASIN ${esc(book.asin)}</span>`:""}
    </div>
    ${(author.email||author.tiktok||author.instagram||author.website||author.goodreads)?`
    <hr class="cover-divider"/>
    <div class="contact-grid">
      ${author.email?`<div class="contact-item"><span class="clabel">Email</span><span class="cval">${esc(author.email)}</span></div>`:""}
      ${author.website?`<div class="contact-item"><span class="clabel">Website</span><span class="cval">${esc(author.website)}</span></div>`:""}
      ${author.tiktok?`<div class="contact-item"><span class="clabel">TikTok</span><span class="cval">${esc(author.tiktok)}</span></div>`:""}
      ${author.instagram?`<div class="contact-item"><span class="clabel">Instagram</span><span class="cval">${esc(author.instagram)}</span></div>`:""}
      ${author.goodreads?`<div class="contact-item"><span class="clabel">Goodreads</span><span class="cval">${esc(author.goodreads)}</span></div>`:""}
      ${author.amazon?`<div class="contact-item"><span class="clabel">Amazon</span><span class="cval">${esc(author.amazon)}</span></div>`:""}
    </div>`:""}
  </div>
</div>

<!-- BOOK DNA -->
${section("Book DNA",`
  ${field("Surface Story",book.surface_story)}
  ${field("Deeper Story",book.deeper_story)}
  ${field("Themes",book.themes)}
  ${field("Reader Audience",book.reader_audience)}
  ${twoCol(field("Comp Authors",book.comp_authors),field("Comp Titles",book.comp_books))}
`)}

<!-- PITCHES -->
${section("Pitches",`
  ${field("One-Sentence Pitch",book.pitch_one_sentence)}
  ${field("Short Pitch / Social",book.pitch_short||book.pitch_social)}
  ${field("Bookstore / Staff Pick",book.pitch_bookstore)}
  ${field("Book Club",book.pitch_book_club)}
  ${field("Agent Pitch",book.pitch_agent)}
  ${field("Publisher Pitch",book.pitch_publisher)}
`)}

<!-- BLURB -->
${section("Blurb",`
  ${field("Tagline",book.blurb_tagline)}
  ${field("Short Blurb",book.blurb_short)}
  ${field("Extended Blurb",book.blurb_extended)}
  ${field("Elevator / 2-Line",book.blurb_elevator)}
  ${field("Content Warnings",book.blurb_cw)}
`)}

<!-- HOOKS -->
${hooksHtml?`<div class="sec pb">
  <div class="sec-head" style="color:${ACCENT};border-bottom:2px solid ${ACCENT}22;">Hooks</div>
  <div class="sec-body">${hooksHtml}</div>
</div>`:""}

<!-- QUOTES -->
${quotesHtml?`<div class="sec pb">
  <div class="sec-head" style="color:${ACCENT2};border-bottom:2px solid ${ACCENT2}22;">Quotes</div>
  <div class="sec-body"><div class="quotes-grid">${quotesHtml}</div></div>
</div>`:""}

<!-- TROPES -->
${(book.tropes&&book.tropes.length)||(book.hidden_tropes||book.char_dynamics||book.rel_dynamics)?section("Tropes & Dynamics",`
  ${(book.tropes&&book.tropes.length)?`<div class="field"><div class="flabel">Main Tropes</div><div class="trope-pills">${(book.tropes||[]).map(t=>`<span class="trope-pill">${esc(t)}</span>`).join("")}</div></div>`:""}
  ${field("Hidden / Micro-Tropes",book.hidden_tropes)}
  ${twoCol(field("Character Dynamics",book.char_dynamics),field("Relationship Dynamics",book.rel_dynamics))}
`):""}

<!-- CHARACTERS -->
${charsHtml?`<div class="sec pb">
  <div class="sec-head" style="color:${ACCENT};border-bottom:2px solid ${ACCENT}22;">Character Profiles</div>
  <div class="sec-body">${charsHtml}</div>
</div>`:""}

<!-- MARKETING -->
${section("Marketing",`
  ${field("Unique Selling Proposition",book.mkt_usp)}
  ${field("Why Readers Will Love It",book.mkt_why)}
  ${twoCol(field("Reader Promise",book.mkt_promise),field("Promise Payoff",book.mkt_payoff))}
  ${twoCol(field("Who It's For",book.mkt_who),field("Why This Reader",book.mkt_why_them))}
  ${twoCol(field("Selling Points",book.mkt_selling),field("Genre Selling Points",book.mkt_genre_selling))}
  ${field("Comp Titles",book.mkt_comps)}
`)}

<!-- CAPTIONS -->
${section("Captions",`
  ${field("Release Week",book.cap_release)}
  ${field("Review Request",book.cap_review)}
  ${field("Reader Reaction",book.cap_reaction)}
  ${field("Have You Read This?",book.cap_haveyouread)}
  ${field("Cover Reveal",book.cap_cover)}
`)}

<!-- TIKTOK -->
${section("TikTok / Reels",`
  ${field("Content Pillars",book.tiktok_content_pillars)}
  ${field("Video Concepts",book.tiktok_ideas)}
  ${twoCol(field("B-Roll Ideas",book.tiktok_broll),field("Text Overlays",book.tiktok_overlays))}
  ${field("Trending Formats",book.tiktok_formats)}
`,ACCENT2)}

<!-- PLAYLIST -->
${(playlistHtml || book.playlist_vibe || book.playlist_link)?`<div class="sec">
  <div class="sec-head" style="color:${ACCENT2};border-bottom:2px solid ${ACCENT2}22;">Playlist</div>
  <div class="sec-body">
    ${field("Vibe / Theme",book.playlist_vibe)}
    ${book.playlist_link?`<div class="field"><div class="flabel">Listen</div><div class="fval">${esc(book.playlist_link)}</div></div>`:""}
    ${playlistHtml?`<div class="playlist">${playlistHtml}</div>`:""}
  </div>
</div>`:""}

<!-- DISCUSSION -->
${section("Discussion & Engagement",`
  ${field("Book Club Questions",book.discuss_bookclub)}
  ${field("Reader Engagement Questions",book.discuss_engagement)}
  ${field("Poll Ideas",book.discuss_polls)}
  ${field("Writing Prompts",book.discuss_prompts)}
`)}

<!-- HASHTAGS -->
${hashStr?`<div class="sec">
  <div class="sec-head" style="color:${ACCENT2};border-bottom:2px solid ${ACCENT2}22;">Hashtags</div>
  <div class="hash-wrap">${(book.hashtags_selected||[]).map(h=>`<span class="hash-pill">${esc(h)}</span>`).join("")}</div>
  ${book.hashtags_custom?`<div style="margin-top:10px;font-size:11px;color:${SUB}">${esc(book.hashtags_custom)}</div>`:""}
</div>`:""}

<!-- COLLABS -->
${section("Collabs & Outreach",`
  ${field("BookTok / Thriller Angles",book.influencer_thriller)}
  ${field("True Crime Angles",book.influencer_truecrime)}
  ${field("Women's Fiction Angles",book.influencer_womens)}
  ${field("Book Club Influencer Angles",book.influencer_bookclub)}
  ${field("Outreach Message Template",book.influencer_outreach)}
  ${twoCol(field("Bookstore Pitches",book.collab_bookstores),field("Podcast Angles",book.collab_podcasts))}
  ${field("Library Pitches",book.collab_libraries)}
`)}

<!-- BONUS TOP 10 -->
${bonusHtml?`<div class="sec pb">
  <div class="sec-head" style="color:${ACCENT};border-bottom:2px solid ${ACCENT}22;">Bonus Top 10</div>
  <div class="sec-body">${bonusHtml}</div>
</div>`:""}

${book.notes?section("Notes",`<div class="fval">${nl(book.notes)}</div>`):""}

<!-- AUTHOR CONTEXT (only when toggle is on) -->
${book.author_notes_export ? section("Author Context",`
  ${field("Author Notes",book.author_notes)}
  ${field("Relationship Facts / Dynamic",book.author_relationship)}
  ${field("Worldbuilding / Series Context",book.author_world)}
  ${field("Do Not Spoil / Guardrails",book.author_guardrails)}
`,ACCENT2) : ""}

<!-- FOOTER -->
<div class="doc-footer">
  <span><strong style="color:${ACCENT}">ContentSync</strong> &mdash; Book Content Pull Package</span>
  <span>Prepared by ${esc(prepName||author.name||"")} &mdash; ${new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</span>
</div>

</div>
</body>
</html>`;

  const win = window.open("","_blank");
  if(!win){ alert("Allow pop-ups for contentsync.netlify.app to export your PDF."); return; }
  win.document.write(html);
  win.document.close();
  win.focus();

  } catch(err){ alert("Export error: "+err.message); }
}


function exportBackup(authors){
  const blob=new Blob([JSON.stringify({version:2,authors,exportedAt:new Date().toISOString()},null,2)],{type:"application/json"});
  const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;
  a.download="ContentSync_Backup_"+new Date().toISOString().slice(0,10)+".json";a.click();URL.revokeObjectURL(url);
}

/* ── UI PRIMITIVES ── */
function Txt({label,value,onChange,rows=3,placeholder=""}){return <div>{label&&<label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</label>}<textarea value={value||""} onChange={e=>onChange(e.target.value)} rows={rows} placeholder={placeholder}/></div>;}
function Inp({label,value,onChange,type="text",placeholder=""}){return <div>{label&&<label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</label>}<input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/></div>;}
function Sel({label,value,onChange,options}){return <div>{label&&<label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</label>}<select value={value||""} onChange={e=>onChange(e.target.value)}><option value="">Select...</option>{options.map(o=><option key={o}>{o}</option>)}</select></div>;}

function TagPicker({label,value=[],onChange,options=[]}){
  const [inp,setInp]=useState("");
  const add=v=>{v=v.trim();if(v&&!value.includes(v))onChange([...value,v]);setInp("");};
  return(<div>
    {label&&<label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</label>}
    <div style={{background:T.inputBg,border:"1px solid "+T.border,borderRadius:6,padding:"6px 8px",minHeight:38,display:"flex",flexWrap:"wrap",gap:5}}>
      {value.map(t=>(<span key={t} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",borderRadius:4,padding:"2px 8px",fontSize:12,color:T.gold,display:"flex",alignItems:"center",gap:4}}>
        {t}<button onClick={()=>onChange(value.filter(x=>x!==t))} style={{background:"none",border:"none",color:T.gold+"88",cursor:"pointer",fontSize:14,lineHeight:1,padding:0}}>x</button>
      </span>))}
      <input value={inp} onChange={e=>setInp(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"||e.key===","){e.preventDefault();add(inp);}}} placeholder="Type and Enter" style={{border:"none",background:"transparent",color:T.text,fontSize:12,padding:"2px 4px",flex:1,minWidth:80,outline:"none"}}/>
    </div>
    {options.length>0&&(<div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:5,maxHeight:100,overflowY:"auto"}}>
      {options.filter(o=>o&&!value.includes(o)).map(o=>(<button key={o} onClick={()=>onChange([...value,o])} style={{background:T.inputBg,border:"1px solid "+T.border,color:T.textMuted,borderRadius:4,padding:"2px 6px",fontSize:11,cursor:"pointer"}}>+{o}</button>))}
    </div>)}
  </div>);
}

function FileUp({label,preview,name,onChange,accept}){
  const ref=useRef();
  return(<div>
    {label&&<label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</label>}
    <div onClick={()=>ref.current.click()} style={{border:"2px dashed "+T.border,borderRadius:8,padding:12,cursor:"pointer",textAlign:"center",background:T.inputBg,transition:"border-color .18s"}} onMouseEnter={e=>e.currentTarget.style.borderColor=T.gold} onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
      {preview?(<div style={{display:"flex",alignItems:"center",gap:8,justifyContent:"center"}}>
        {accept.includes("image")&&<img src={preview} alt="" style={{width:40,height:54,objectFit:"cover",borderRadius:3}}/>}
        <span style={{fontSize:11,color:T.gold,wordBreak:"break-all"}}>{name}</span>
      </div>):(<div style={{fontSize:11,color:T.textMuted}}>Click to upload</div>)}
      <input ref={ref} type="file" accept={accept} style={{display:"none"}} onChange={e=>{const file=e.target.files[0];if(!file)return;if(accept.includes("image")){const r=new FileReader();r.onload=ev=>onChange(ev.target.result,file.name);r.readAsDataURL(file);}else onChange(URL.createObjectURL(file),file.name);}}/>
    </div>
  </div>);
}

function Coll({title,icon="",accent,children,open:initOpen=false}){
  const ac=accent||T.gold;
  const [open,setOpen]=useState(initOpen);
  return(<div style={{marginBottom:8}}>
    <button onClick={()=>setOpen(o=>!o)} style={{width:"100%",background:open?T.panelBg:"transparent",border:"1px solid "+(open?ac+"44":T.border),borderRadius:open?"8px 8px 0 0":8,padding:"9px 12px",display:"flex",alignItems:"center",gap:8,cursor:"pointer",transition:"all .15s"}}>
      {icon&&<span style={{fontSize:14}}>{icon}</span>}
      <span style={{fontFamily:"'Playfair Display',serif",fontWeight:600,fontSize:13,color:open?ac:T.text,flex:1,textAlign:"left"}}>{title}</span>
      <span style={{color:T.textMuted,fontSize:11}}>{open?"^":"v"}</span>
    </button>
    {open&&<div style={{background:T.deepBg,border:"1px solid "+T.border,borderTop:"none",borderRadius:"0 0 8px 8px",padding:"14px 12px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>{children}</div>}
  </div>);
}
function Full({children}){return <div style={{gridColumn:"1/-1"}}>{children}</div>;}
function Half({children}){return <div>{children}</div>;}

function BankPanel({items,onUse}){
  const [q,setQ]=useState("");const [cp,setCp]=useState(null);
  const fl=items.filter(it=>!q||it.toLowerCase().includes(q.toLowerCase()));
  const copy=(t,i)=>{navigator.clipboard.writeText(t).catch(()=>{});setCp(i);setTimeout(()=>setCp(null),1400);};
  return(<div>
    <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Filter..." style={{marginBottom:7,fontSize:12}}/>
    <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:260,overflowY:"auto"}}>
      {fl.map((t,i)=>(<div key={i} style={{display:"flex",alignItems:"flex-start",gap:6,background:T.panelBg,border:"1px solid "+T.border,borderRadius:5,padding:"6px 9px"}}>
        <span style={{fontSize:12,flex:1,color:T.textSub,lineHeight:1.5}}>{t}</span>
        <div style={{display:"flex",gap:4,flexShrink:0,paddingTop:1}}>
          {onUse&&<button onClick={()=>onUse(t)} style={{background:"none",border:"none",color:T.teal,cursor:"pointer",fontSize:11}}>use</button>}
          <button onClick={()=>copy(t,i)} style={{background:"none",border:"none",color:cp===i?T.teal:T.textMuted,cursor:"pointer",fontSize:11}}>{cp===i?"ok":"copy"}</button>
        </div>
      </div>))}
    </div>
  </div>);
}



/* ── IMPORT PANEL ── */
function ImportPanel({authors,setAuthors,showToast}){
  const [selA,setSelA]=useState(authors[0]?.id||"");
  const [selB,setSelB]=useState(authors[0]?.books[0]?.id||"");
  const [raw,setRaw]=useState("");
  const [preview,setPreview]=useState(null);
  const [done,setDone]=useState(false);
  const [loading,setLoading]=useState(false);
  const [fileName,setFileName]=useState("");
  const fileRef=useRef();

  const author=authors.find(a=>a.id===selA);

  const handleAuthorChange=(aid)=>{
    setSelA(aid);
    const a=authors.find(x=>x.id===aid);
    setSelB(a?.books[0]?.id||"");
    setPreview(null);setDone(false);
  };

  // Read file and extract text based on type
  const handleFile=async(e)=>{
    const file=e.target.files[0];
    if(!file)return;
    setFileName(file.name);
    setPreview(null);setDone(false);setLoading(true);
    const ext=file.name.split(".").pop().toLowerCase();

    try{
      if(ext==="txt"||ext==="md"){
        // Plain text / markdown
        const text=await file.text();
        setRaw(text);
        setLoading(false);

      }else if(ext==="pdf"){
        // PDF — use FileReader to get base64, send to Claude API to extract text
        const reader=new FileReader();
        reader.onload=async(ev)=>{
          try{
            const base64=ev.target.result.split(",")[1];
            const resp=await fetch("https://api.anthropic.com/v1/messages",{
              method:"POST",
              headers:{"Content-Type":"application/json"},
              body:JSON.stringify({
                model:"claude-sonnet-4-6",
                max_tokens:8000,
                messages:[{role:"user",content:[
                  {type:"document",source:{type:"base64",media_type:"application/pdf",data:base64}},
                  {type:"text",text:"Extract all the text from this document exactly as written. Preserve all section headers, labels, and content. Output only the raw text content, nothing else."}
                ]}]
              })
            });
            const data=await resp.json();
            const text=data.content?.map(c=>c.text||"").join("\n")||"";
            setRaw(text);
          }catch(err){showToast("Could not read PDF. Try copying and pasting the text instead.");}
          setLoading(false);
        };
        reader.readAsDataURL(file);

      }else if(ext==="docx"||ext==="doc"){
        // DOCX — use mammoth via FileReader
        const reader=new FileReader();
        reader.onload=async(ev)=>{
          try{
            // Dynamically load mammoth
            if(!window.mammoth){
              await new Promise((res,rej)=>{
                const s=document.createElement("script");
                s.src="https://cdnjs.cloudflare.com/ajax/libs/mammoth/1.6.0/mammoth.browser.min.js";
                s.onload=res;s.onerror=rej;
                document.head.appendChild(s);
              });
            }
            const result=await window.mammoth.extractRawText({arrayBuffer:ev.target.result});
            setRaw(result.value||"");
          }catch(err){showToast("Could not read DOCX. Try saving as .txt and uploading that.");}
          setLoading(false);
        };
        reader.readAsArrayBuffer(file);

      }else if(ext==="rtf"||ext==="pages"||ext==="odt"){
        // Unsupported native format — try reading as text anyway
        try{
          const text=await file.text();
          // Strip RTF control codes if present
          const cleaned=text.replace(/\{\\[^}]+\}/g,"").replace(/\\[a-z]+\d*\s?/g,"").replace(/[{}]/g,"").trim();
          setRaw(cleaned.length>100?cleaned:text);
        }catch(err){
          showToast("This file format is not directly supported. Export as PDF, DOCX, or TXT first.");
        }
        setLoading(false);

      }else{
        showToast("Supported formats: PDF, DOCX, TXT, MD. For Pages or Vellum docs, export as PDF or DOCX first.");
        setLoading(false);
      }
    }catch(err){
      showToast("Error reading file. Try a different format.");
      setLoading(false);
    }
    e.target.value="";
  };

  const parse=(text)=>{
    const lines=text.split("\n");
    const fields={};
    const labelMap=[
      ["Title","title"],["Series Number","seriesNum"],["Series","series"],["Genre","genre_raw"],
      ["Surface Story","surface_story"],["Deeper Story","deeper_story"],["Themes","themes"],
      ["Reader Audience","reader_audience"],["Comp Authors","comp_authors"],
      ["Comp Titles","comp_books"],["Comp Books","comp_books"],
      ["One-Sentence Pitch","pitch_one_sentence"],["One-Sentence","pitch_one_sentence"],
      ["Short Pitch","pitch_short"],["Agent Pitch","pitch_agent"],
      ["Publisher Pitch","pitch_publisher"],["Bookstore / Staff Pick","pitch_bookstore"],
      ["Bookstore","pitch_bookstore"],["Book Club Pitch","pitch_book_club"],
      ["Book Club","pitch_book_club"],["Social Pitch","pitch_social"],
      ["Social Media Pitch","pitch_social"],["USP","mkt_usp"],
      ["Unique Selling Proposition","mkt_usp"],["Why Readers Will Love It","mkt_why"],
      ["Reader Promise","mkt_promise"],["Promise Payoff","mkt_payoff"],
      ["Selling Points","mkt_selling"],["Genre Selling Points","mkt_genre_selling"],
      ["Release Week","cap_release"],["Review Request","cap_review"],
      ["Have You Read This","cap_haveyouread"],["Reader Reaction","cap_reaction"],
      ["Cover Reveal","cap_cover"],["Content Pillars","tiktok_content_pillars"],
      ["Text Overlays","tiktok_overlays"],["Video Concepts","tiktok_ideas"],
      ["Top 10 Most Marketable","bonus_moments"],["Most Marketable Moments","bonus_moments"],
      ["Top 10 Best Lines","bonus_graphics"],["Best Lines for Graphics","bonus_graphics"],
      ["Scream-Worthy Quotes","bonus_quotes"],["Most Emotional Scenes","bonus_emotional"],
      ["Most Relatable","bonus_relatable"],["Scenes Most Likely","bonus_scenes"],
      ["Top 10 Scenes","bonus_scenes"],["Main Tropes","tropes_raw"],
      ["Hidden / Micro-Tropes","hidden_tropes"],["Hidden Tropes","hidden_tropes"],
      ["Character Dynamics","char_dynamics"],["Relationship Dynamics","rel_dynamics"],
      ["Curiosity Hooks","hooks_curiosity"],["Curiosity","hooks_curiosity"],
      ["Emotional Hooks","hooks_emotional"],["Emotional","hooks_emotional"],
      ["Character Hooks","hooks_character"],["Character","hooks_character"],
      ["POV Hooks","hooks_pov"],["Fear / Tension","hooks_fear"],["Fear","hooks_fear"],
      ["Teaser Hooks","hooks_teaser"],["Teaser","hooks_teaser"],
      ["Viral BookTok","hooks_viral"],["Viral","hooks_viral"],
      ["Scroll-Stopping","hooks_scroll"],["Comment-Bait","hooks_comment"],
      ["Influencer Outreach","influencer_outreach"],["Thriller","influencer_thriller"],
      // ── Blurb ──
      ["Tagline","blurb_tagline"],["Short Blurb","blurb_short"],["Extended Blurb","blurb_extended"],
      ["Elevator / 2-Line","blurb_elevator"],["Elevator Blurb","blurb_elevator"],["2-Line Blurb","blurb_elevator"],
      ["Content Warnings","blurb_cw"],["Content Warning","blurb_cw"],
      // ── Marketing (extra) ──
      ["Who It's For","mkt_who"],["Who Is Your Target Reader","mkt_who"],["Target Reader","mkt_who"],
      ["Why This Reader","mkt_why_them"],["Marketing Comp Titles","mkt_comps"],["Marketing Comps","mkt_comps"],
      // ── TikTok (extra) ──
      ["B-Roll Ideas","tiktok_broll"],["B-Roll","tiktok_broll"],["Trending Formats","tiktok_formats"],
      // ── Hooks (extra) ──
      ["One-Sentence Pitch Hooks","hooks_pitch"],["Pitch Hooks","hooks_pitch"],
      // ── Discussion ──
      ["Book Club Questions","discuss_bookclub"],["Reader Engagement Questions","discuss_engagement"],
      ["Engagement Questions","discuss_engagement"],["Poll Ideas","discuss_polls"],["Polls","discuss_polls"],
      ["Writing Prompts","discuss_prompts"],["Prompts","discuss_prompts"],
      // ── Collabs & Outreach ──
      ["BookTok / Thriller Angles","influencer_thriller"],["Thriller / Suspense Angles","influencer_thriller"],
      ["True Crime Angles","influencer_truecrime"],["Women's Fiction Angles","influencer_womens"],
      ["Book Club Influencer Angles","influencer_bookclub"],["Book Club Angles","influencer_bookclub"],
      ["Outreach Message Template","influencer_outreach"],["Outreach Template","influencer_outreach"],
      ["Bookstore Pitches","collab_bookstores"],["Podcast Angles","collab_podcasts"],["Library Pitches","collab_libraries"],
      // ── Graphics ──
      ["Canva / Promo Copy","graphics_canva"],["Promo Copy","graphics_canva"],
      ["Aesthetic Post Copy","graphics_aesthetic"],["Aesthetic Copy","graphics_aesthetic"],
      // ── Bonus (extra) ──
      ["Top 10 Best Character Arc Moments","bonus_arcs"],["Best Character Arc Moments","bonus_arcs"],["Character Arc Moments","bonus_arcs"],
      ["Top 10 Lines That Hit Harder on Reread","bonus_lines"],["Lines That Hit Harder on Reread","bonus_lines"],["Lines That Hit Harder","bonus_lines"],
      // ── Author Notes (reference) ──
      ["Author-Supplied Notes","author_notes"],["Author Notes","author_notes"],
      ["Relationship Facts / Dynamic","author_relationship"],["Relationship Facts","author_relationship"],
      ["Worldbuilding / Series Context","author_world"],["Worldbuilding","author_world"],
      ["Do Not Spoil / Guardrails","author_guardrails"],["Guardrails","author_guardrails"],
      // ── Playlist ──
      ["Playlist Vibe","playlist_vibe"],["Overall Vibe / Theme","playlist_vibe"],["Vibe / Theme","playlist_vibe"],
      ["Streaming Link","playlist_link"],["Playlist Link","playlist_link"],
      // ── Metadata ──
      ["Publisher","publisher"],["ISBN","isbn"],["ASIN","asin"],
      ["Page Count","page_count"],["Word Count","word_count"],
      ["Subtitle","subtitle"],["Notes","notes"],
      ["Custom Hashtags","hashtags_custom"],
    ];
    let currentKey=null;
    let buffer=[];
    const flush=()=>{
      if(currentKey&&buffer.length){
        const val=buffer.join("\n").trim();
        if(val){
          if(fields[currentKey])fields[currentKey]+="\n\n"+val;
          else fields[currentKey]=val;
        }
      }
      buffer=[];currentKey=null;
    };
    const cleanLine=(l)=>l.replace(/^\*\*|\*\*$/g,"").replace(/^#+\s*/,"").trim();
    const isLabel=(l)=>{
      const c=cleanLine(l);
      return labelMap.some(([lbl])=>c.toLowerCase()===lbl.toLowerCase()||c.toLowerCase().startsWith(lbl.toLowerCase()+":"));
    };
    const getKey=(l)=>{
      const c=cleanLine(l).replace(/:.*$/,"").trim();
      const match=labelMap.find(([lbl])=>c.toLowerCase()===lbl.toLowerCase());
      return match?match[1]:null;
    };
    const getInlineVal=(l)=>{
      const colonIdx=l.indexOf(":");
      if(colonIdx>0){const after=l.slice(colonIdx+1).replace(/^\*\*|\*\*/g,"").trim();if(after)return after;}
      return "";
    };
    lines.forEach(line=>{
      const trimmed=line.trim();
      if(!trimmed){buffer.push("");return;}
      const isBold=trimmed.startsWith("**")&&trimmed.includes("**");
      const isHash=trimmed.startsWith("#");
      const labelTest=(isBold||isHash)&&isLabel(trimmed);
      if(labelTest){
        flush();currentKey=getKey(trimmed);
        const inline=getInlineVal(trimmed);if(inline)buffer.push(inline);
      }else{buffer.push(trimmed.replace(/^[-*•▸■]\s*/,""));}
    });
    flush();
    const tropeList=(fields.tropes_raw||"").split(/[,\n•]/).map(t=>t.replace(/^\*\*|\*\*$/g,"").trim()).filter(t=>t.length>2&&t.length<70);
    delete fields.tropes_raw;
    const genreList=fields.genre_raw?[fields.genre_raw.split(/[,/]/)[0].trim()]:[];
    delete fields.genre_raw;
    const hashList=[...new Set((text.match(/#\w+/g)||[]))].slice(0,60);
    const quoteLines=lines.filter(l=>l.includes('"')&&l.trim().length>10);
    const quotes=quoteLines.slice(0,100).map((l,i)=>{
      const m=l.match(/"([^"]+)"/);
      if(!m)return null;
      // Parse an optional trailing tag like: (Ch. 12 — Aeron, the confession)
      const tag=l.match(/\(\s*ch\.?\s*([0-9]+)\s*(?:[—\-–:]\s*(.+?))?\s*\)/i);
      return {id:Date.now()+i,text:m[1].trim(),type:"General",chapter:tag?tag[1]:"",pg:"",line:"",notes:(tag&&tag[2])?tag[2].trim():""};
    }).filter(Boolean);
    return{...fields,tropes:tropeList,genres:genreList,hashtags_selected:hashList,quotes};
  };

  const handlePreview=()=>{
    if(!raw.trim()){showToast("Upload a file or paste text first.");return;}
    setPreview(parse(raw));setDone(false);
  };

  const handleImport=()=>{
    if(!preview||!selB){showToast("Select a book and preview first.");return;}
    setAuthors(as=>as.map(a=>{
      if(a.id!==selA)return a;
      return{...a,books:a.books.map(b=>{
        if(b.id!==selB)return b;
        const merged={...b};
        Object.entries(preview).forEach(([k,v])=>{
          if(!v||(Array.isArray(v)&&v.length===0))return;
          if(Array.isArray(v)){
            if(k==="quotes")merged[k]=[...(merged[k]||[]),...v];
            else if(k==="tropes"||k==="hashtags_selected"||k==="genres")merged[k]=[...new Set([...(merged[k]||[]),...v])];
            else merged[k]=v;
          }else if(typeof v==="string"&&v.trim()){
            merged[k]=merged[k]?(merged[k]+"\n\n"+v):v;
          }else if(!merged[k]){merged[k]=v;}
        });
        return merged;
      })};
    }));
    setDone(true);setRaw("");setPreview(null);setFileName("");
    showToast("Imported! Check each tab — all detected fields have been filled.");
  };

  const fieldCount=preview?Object.entries(preview).filter(([,v])=>v&&(Array.isArray(v)?v.length>0:String(v).trim())).length:0;

  return(
    <div style={{maxWidth:680}}>
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:180}}>
          <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>Author</label>
          <select value={selA} onChange={e=>handleAuthorChange(e.target.value)} style={{width:"100%"}}>
            {authors.map(a=><option key={a.id} value={a.id}>{a.name||"Unnamed Author"}</option>)}
          </select>
        </div>
        <div style={{flex:1,minWidth:180}}>
          <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>Book</label>
          <select value={selB} onChange={e=>{setSelB(e.target.value);setPreview(null);setDone(false);}} style={{width:"100%"}}>
            {(author?.books||[]).map(b=><option key={b.id} value={b.id}>{b.title||"Untitled Book"}</option>)}
          </select>
        </div>
      </div>

      <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:6}}>Upload Document</label>
      <div onClick={()=>fileRef.current?.click()} style={{border:"2px dashed "+T.border,borderRadius:8,padding:"20px",textAlign:"center",cursor:"pointer",background:T.inputBg,marginBottom:10,transition:"border-color .15s"}} onMouseEnter={e=>e.currentTarget.style.borderColor=T.gold} onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
        {loading?(<div style={{color:T.textMuted,fontSize:12}}>Reading file...</div>):fileName?(<div><div style={{color:T.gold,fontSize:13,fontWeight:600,marginBottom:3}}>{fileName}</div><div style={{color:T.textMuted,fontSize:11}}>Click to replace</div></div>):(<div><div style={{color:T.textSub,fontSize:13,marginBottom:4}}>Click to upload your document</div><div style={{color:T.textMuted,fontSize:11}}>PDF, DOCX, TXT, MD supported<br/>For Pages or Vellum files — export as PDF or DOCX first</div></div>)}
        <input ref={fileRef} type="file" accept=".pdf,.docx,.doc,.txt,.md,.rtf" style={{display:"none"}} onChange={handleFile}/>
      </div>

      <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>Or Paste Text Directly</label>
      <textarea value={raw} onChange={e=>{setRaw(e.target.value);setPreview(null);setDone(false);}} rows={6} placeholder={"Paste your content pull document here — uses **bold labels** and ## headers to detect fields."} style={{marginBottom:10,fontFamily:"monospace",fontSize:11}}/>

      <div style={{display:"flex",gap:8,marginBottom:12}}>
        <button onClick={handlePreview} disabled={loading||!raw.trim()} style={{background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:6,padding:"8px 16px",fontSize:12,fontWeight:600,cursor:"pointer",opacity:loading||!raw.trim()?0.5:1}}>Preview Import</button>
        {preview&&<button onClick={handleImport} style={{background:T.gold,color:"#0D1821",border:"none",borderRadius:6,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>Import {fieldCount} Fields into Book</button>}
      </div>

      {preview&&!done&&(
        <div style={{background:T.sideBg,border:"1px solid "+T.border,borderRadius:8,padding:"14px 16px"}}>
          <div style={{fontSize:12,fontWeight:600,color:T.gold,marginBottom:10}}>{fieldCount} fields detected — review before importing</div>
          <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:340,overflowY:"auto"}}>
            {Object.entries(preview).filter(([,v])=>v&&(Array.isArray(v)?v.length>0:String(v).trim())).map(([k,v])=>(
              <div key={k} style={{background:T.deepBg,borderRadius:5,padding:"7px 10px"}}>
                <div style={{fontSize:9,fontWeight:600,letterSpacing:"0.07em",textTransform:"uppercase",color:T.textMuted,marginBottom:3}}>{k.replace(/_/g," ")}</div>
                <div style={{fontSize:11,color:T.textSub,lineHeight:1.5}}>
                  {Array.isArray(v)?v.slice(0,3).join(", ")+(v.length>3?" +"+v.length+" total":""):String(v).slice(0,200)+(String(v).length>200?"...":"")}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {done&&(
        <div style={{background:T.teal+"22",border:"1px solid "+T.teal+"55",borderRadius:8,padding:"14px 16px",fontSize:12,color:T.teal}}>
          Import complete! Navigate to the book and check each tab — all detected fields have been filled. Existing content was preserved and new content was appended.
        </div>
      )}
    </div>
  );
}


/* ── ADMIN PANEL ── */
function AdminPanel({onExit,authors=[],setAuthors=()=>{}}){
  const [tab,setTab]=useState("users");
  const [nm,setNm]=useState(""); const [em,setEm]=useState(""); const [exp,setExp]=useState("");
  const [res,setRes]=useState(null); const [sending,setSending]=useState(false);
  const [toast,setToast]=useState(null); const [q,setQ]=useState("");
  const [codesVersion,setCodesVersion]=useState(0); // bump to re-read codes after edits
  const getCodes=()=>{try{return JSON.parse(localStorage.getItem(CODES_KEY)||"[]");}catch(e){return[];}};
  const expMap=getExpiryMap();
  const withExp=u=>({...u, expires: expMap[u.code] || u.expires || ""});
  const all=[...LEGACY_USERS.map(u=>withExp({...u,joined:"Pre-launch"})),...getCodes().map(u=>withExp({...u,role:"subscriber",joined:u.date?new Date(u.date).toLocaleDateString():""}))];
  const show=all.filter(u=>!q||(u.name||"").toLowerCase().includes(q.toLowerCase())||(u.email||"").toLowerCase().includes(q.toLowerCase())||(u.code||"").toLowerCase().includes(q.toLowerCase()));
  const st=msg=>{setToast(msg);setTimeout(()=>setToast(null),2500);};
  // Schedule (or clear) an end date for ANY user — legacy or generated.
  // Writes to the universal expiry store so it works even for hardcoded legacy users.
  const setExpiry=(code,date)=>{
    setExpiryFor(code,date);
    // Keep generated-code records in sync too, so older logic still sees it.
    const stored=getCodes();
    const i=stored.findIndex(u=>u.code===code);
    if(i>=0){ if(date) stored[i].expires=date; else delete stored[i].expires; localStorage.setItem(CODES_KEY,JSON.stringify(stored)); }
    setCodesVersion(v=>v+1);
    st(date?("Scheduled to end "+date):"Schedule cleared");
  };
  const doGen=async()=>{
    if(!nm.trim()){setRes({err:"Enter a name."});return;}
    const code=genCode();
    const stored=getCodes(); const rec={code,name:nm.trim(),email:em.trim(),date:new Date().toISOString()};
    if(exp) rec.expires=exp;
    stored.push(rec);
    localStorage.setItem(CODES_KEY,JSON.stringify(stored));
    setRes({code,name:nm,email:em,expires:exp});
    if(em.trim()){setSending(true);try{await sendEmail(em.trim(),nm.trim(),code);st("Code generated and emailed!");}catch(e){st("Generated - email failed. Copy manually.");}setSending(false);}
    else st("Code generated! Copy it manually.");
    setNm("");setEm("");setExp("");
  };
  const rc=r=>r==="admin"?T.rose:r==="beta"?T.teal:r==="subscriber"?T.gold:T.textMuted;
  return(
    <div style={{display:"flex",flexDirection:"column",height:"100dvh",background:T.pageBg}}>
      <div style={{background:T.sideBg,borderBottom:"1px solid "+T.border,padding:"12px 20px",display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700}}><span style={{color:T.gold}}>Content</span><span style={{color:T.text}}>Sync</span></span>
        <span style={{fontSize:11,background:T.rose+"22",border:"1px solid "+T.rose+"55",color:T.rose,borderRadius:4,padding:"1px 8px"}}>Admin</span>
        <div style={{flex:1}}/>
        <button onClick={onExit} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:6,padding:"5px 14px",fontSize:12,cursor:"pointer"}}>Exit Admin</button>
      </div>
      <div style={{background:T.sideBg,borderBottom:"1px solid "+T.border,padding:"0 20px",display:"flex"}}>
        {[["users","All Users ("+all.length+")"],["gen","Generate Code"],["dupes","Duplicates"],["import","Bulk Import"]].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)} style={{background:"none",border:"none",borderBottom:"2px solid "+(tab===k?T.gold:"transparent"),color:tab===k?T.gold:T.textMuted,padding:"9px 14px 7px",fontSize:12,fontWeight:tab===k?600:400,cursor:"pointer",whiteSpace:"nowrap"}}>{l}</button>
        ))}
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"20px"}}>
        {tab==="users"&&(<div>
          <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
            <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search name, email, or code..." style={{flex:1,minWidth:200}}/>
            <span style={{fontSize:12,color:T.textMuted,alignSelf:"center"}}>{show.length}/{all.length}</span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {show.map((u,i)=>{
              const isSub=u.role==="subscriber";
              const isAdminCode=u.role==="admin"||u.code==="SSDD-ADMIN7655";
              const canSchedule=!isAdminCode;
              const exp=codeExpired(u);
              return(<div key={u.code||i} style={{background:T.sideBg,border:"1px solid "+(exp?T.rose+"99":u.duplicate?T.rose+"55":T.border),borderRadius:7,padding:"9px 12px",display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:8,alignItems:"center"}}>
              <div><div style={{fontSize:12,fontWeight:600,color:T.text}}>{u.name||"—"}</div><div style={{fontSize:10,color:T.textMuted}}>{u.email||"No email"}</div></div>
              <div style={{fontFamily:"monospace",fontSize:11,color:exp?T.textMuted:T.gold,textDecoration:exp?"line-through":"none"}}>{u.code}</div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap",alignItems:"center",justifyContent:"flex-end"}}>
                <span style={{fontSize:9,background:rc(u.role)+"22",color:rc(u.role),border:"1px solid "+rc(u.role)+"44",borderRadius:3,padding:"1px 5px"}}>{u.role}</span>
                {u.duplicate&&<span style={{fontSize:9,background:T.rose+"22",color:T.rose,border:"1px solid "+T.rose+"55",borderRadius:3,padding:"1px 5px"}}>dupe</span>}
                {u.expires&&<span style={{fontSize:9,background:(exp?T.rose:T.teal)+"22",color:exp?T.rose:T.teal,border:"1px solid "+(exp?T.rose:T.teal)+"55",borderRadius:3,padding:"1px 5px"}}>{exp?"expired "+u.expires:"until "+u.expires}</span>}
                {canSchedule&&(
                  <input type="date" value={u.expires||""} onChange={e=>setExpiry(u.code,e.target.value)} title="Schedule access end date"
                    style={{width:138,fontSize:10,padding:"3px 6px"}}/>
                )}
                {canSchedule&&u.expires&&(
                  <button onClick={()=>setExpiry(u.code,"")} title="Remove end date" style={{background:"none",border:"1px solid "+T.border,color:T.textMuted,borderRadius:4,padding:"3px 6px",fontSize:10,cursor:"pointer"}}>clear</button>
                )}
                <button onClick={()=>{navigator.clipboard.writeText(u.code).catch(()=>{});st("Copied!");}} style={{background:"none",border:"1px solid "+T.border,color:T.textMuted,borderRadius:4,padding:"3px 8px",fontSize:10,cursor:"pointer"}}>Copy</button>
              </div>
            </div>);
            })}
          </div>
        </div>)}
        {tab==="gen"&&(<div style={{maxWidth:480}}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,fontWeight:600,color:T.text,marginBottom:4}}>Generate Access Code</div>
          <div style={{fontSize:12,color:T.textMuted,marginBottom:18}}>Creates a SHELF- code. Email is optional. Set an end date to schedule automatic deactivation.</div>
          <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:14}}>
            <Inp label="Name *" value={nm} onChange={setNm} placeholder="User's name"/>
            <Inp label="Email (optional)" value={em} onChange={setEm} placeholder="Will auto-send welcome email"/>
            <div>
              <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:6}}>Access Until (optional)</label>
              <input type="date" value={exp} onChange={e=>setExp(e.target.value)} style={{width:"100%"}}/>
              <div style={{fontSize:10,color:T.textMuted,marginTop:4}}>Leave blank for no expiry. Access is allowed through this whole day and stops the next day.</div>
            </div>
          </div>
          <button onClick={doGen} disabled={sending} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700,marginBottom:14,opacity:sending?0.7:1}}>{sending?"Sending...":"Generate Code"}</button>
          {res&&!res.err&&(<div style={{background:T.sideBg,border:"1px solid "+T.gold,borderRadius:10,padding:"20px",textAlign:"center"}}>
            <div style={{fontSize:10,color:T.textMuted,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:8}}>Code for {res.name}</div>
            <div style={{fontFamily:"monospace",fontSize:24,fontWeight:700,color:T.gold,letterSpacing:"0.15em",marginBottom:10}}>{res.code}</div>
            <button onClick={()=>{navigator.clipboard.writeText(res.code).catch(()=>{});st("Copied!");}} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:6,padding:"6px 16px",fontSize:12,cursor:"pointer"}}>Copy Code</button>
            {res.email&&<div style={{fontSize:11,color:T.teal,marginTop:10}}>Emailed to {res.email}</div>}
            {res.expires&&<div style={{fontSize:11,color:T.gold,marginTop:6}}>Scheduled to deactivate on {res.expires}</div>}
          </div>)}
          {res?.err&&<div style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",borderRadius:7,padding:"10px",fontSize:12,color:T.rose}}>{res.err}</div>}
        </div>)}

        
        {tab==="import"&&(<div>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,fontWeight:600,color:T.text,marginBottom:4}}>Bulk Import Content Pull</div>
          <div style={{fontSize:12,color:T.textMuted,marginBottom:14,lineHeight:1.6}}>Paste a full content pull document below. Select the author and book to import into, then click Import. Fields are appended — existing content is not overwritten.</div>
          <ImportPanel authors={authors} setAuthors={setAuthors} showToast={st}/>
        </div>)}
        {tab==="dupes"&&(<div>
          <div style={{background:T.rose+"11",border:"1px solid "+T.rose+"33",borderRadius:8,padding:"12px 16px",marginBottom:14,fontSize:12,color:T.rose}}>These users have multiple codes on file. Recommend keeping the most recent.</div>
          {[{name:"Ali Shipley",email:"Mybookishcorner10@gmail.com",codes:["SSDD-AS1048","SSDD-AS1091"]},{name:"Chloe Adcock",email:"cadcock06@icloud.com",codes:["SSDD-CA0668","SSDD-CA0664"]},{name:"Rebekah Turnbull",email:"onceuponapaservices@gmail.com",codes:["SSDD-RTES94","SSDD-RTES66"]}].map((d,i)=>(
            <div key={i} style={{background:T.sideBg,border:"1px solid "+T.rose+"55",borderRadius:8,padding:"12px 16px",marginBottom:8}}>
              <div style={{fontSize:13,fontWeight:600,color:T.text}}>{d.name}</div>
              <div style={{fontSize:11,color:T.textMuted,marginBottom:8}}>{d.email}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {d.codes.map(c=>(<div key={c} style={{background:T.deepBg,border:"1px solid "+T.border,borderRadius:6,padding:"5px 10px",display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontFamily:"monospace",fontSize:12,color:T.gold}}>{c}</span>
                  <button onClick={()=>{navigator.clipboard.writeText(c).catch(()=>{});st("Copied!");}} style={{background:"none",border:"none",color:T.textMuted,cursor:"pointer",fontSize:11}}>copy</button>
                </div>))}
              </div>
            </div>
          ))}
        </div>)}
      </div>
      {toast&&<div style={{position:"fixed",bottom:20,left:"50%",transform:"translateX(-50%)",background:T.teal,color:"#fff",borderRadius:7,padding:"9px 18px",fontSize:12,fontWeight:600,zIndex:999,boxShadow:"0 4px 16px #0009",whiteSpace:"nowrap"}}>{toast}</div>}
    </div>
  );
}

/* ── GRACE BANNER ── */
function GraceBanner({name}){
  const d=daysLeft();
  if(graceExpired())return null;
  return(
    <div style={{background:T.gold+"0F",borderBottom:"1px solid "+T.gold+"33",padding:"9px 16px",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",flexShrink:0}}>
      <span style={{fontSize:11,color:T.gold,flex:1,lineHeight:1.5}}>Hi {name||"there"} -- ContentSync is moving to $9.99/month. As a valued early user, you have free access until July 17, 2026 ({d} day{d!==1?"s":""} remaining). Subscribe before then to keep your access uninterrupted -- no data is lost.</span>
      <a href={"https://www.paypal.com/webapps/billing/plans/subscribe?plan_id="+PAYPAL_PLAN_ID} target="_blank" rel="noopener noreferrer" style={{background:T.gold,color:"#0D1821",borderRadius:6,padding:"6px 14px",fontSize:11,fontWeight:700,textDecoration:"none",whiteSpace:"nowrap"}}>Subscribe $9.99/mo</a>
    </div>
  );
}

/* ── GRACE EXPIRED ── */
function CodeExpiredScreen({name,onOut}){
  return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",background:T.pageBg,padding:20}}>
      <div style={{maxWidth:440,width:"100%",background:T.sideBg,border:"1px solid "+T.border,borderRadius:14,padding:"32px 28px",textAlign:"center"}}>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:700,color:T.text,marginBottom:6}}>
          <span style={{color:T.gold}}>Content</span>Sync
        </div>
        <div style={{fontSize:13,color:T.text,fontWeight:600,marginBottom:10}}>{name?name+", your":"Your"} access has ended</div>
        <div style={{fontSize:12.5,color:T.textMuted,lineHeight:1.7,marginBottom:22}}>
          Your access code reached its scheduled end date. Your saved authors, books, and content are still safely stored on this device &mdash; nothing has been deleted. To pick back up, reach out to renew your access.
        </div>
        <button onClick={onOut} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:700,cursor:"pointer"}}>Return to Sign In</button>
      </div>
    </div>
  );
}
function GraceExpiredScreen({name,onOut}){
  const [em,setEm]=useState(""); const [nm,setNm]=useState(name||"");
  const [loading,setLoading]=useState(false); const [code,setCode]=useState(null); const [err,setErr]=useState("");
  const ppRef=useRef(null); const ppDone=useRef(false);
  useEffect(()=>{
    loadPP(()=>{
      const tryRender=(attempts=0)=>{
        if(attempts>30)return;
        if(!ppRef.current||!window.paypal){setTimeout(()=>tryRender(attempts+1),150);return;}
        if(ppDone.current)return;
        ppDone.current=true;
        window.paypal.Buttons({
          style:{shape:"rect",color:"gold",layout:"vertical",label:"subscribe"},
          createSubscription:(d,a)=>a.subscription.create({plan_id:PAYPAL_PLAN_ID}),
          onApprove:async(d)=>{
            setLoading(true);const c=genCode();
            const stored=JSON.parse(localStorage.getItem(CODES_KEY)||"[]");
            stored.push({code:c,name:nm,email:em,subId:d.subscriptionID,date:new Date().toISOString()});
            localStorage.setItem(CODES_KEY,JSON.stringify(stored));
            localStorage.setItem(ACCESS_KEY,JSON.stringify({code:c,email:em,name:nm,subscribed:true,unlockedAt:new Date().toISOString()}));
            await sendEmail(em,nm,c).catch(()=>{}); await sendNotif(em,nm,c).catch(()=>{});
            setCode(c); setLoading(false);
          },
          onError:()=>setErr("Payment failed. Please try again.")
        }).render(ppRef.current);
      };
      tryRender();
    });
  },[]);
  if(code)return(<div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:20,background:T.pageBg}}><div style={{background:T.sideBg,border:"1px solid "+T.border,borderRadius:14,padding:"36px 32px",maxWidth:420,width:"100%",textAlign:"center"}}><div style={{fontFamily:"'Playfair Display',serif",fontSize:20,fontWeight:600,color:T.text,marginBottom:8}}>You are back in!</div><div style={{fontSize:13,color:T.textSub,marginBottom:18}}>Your new access code -- save it!</div><div style={{background:T.deepBg,border:"1px solid "+T.gold,borderRadius:8,padding:"18px",marginBottom:18}}><div style={{fontFamily:"monospace",fontSize:24,fontWeight:700,color:T.gold,letterSpacing:"0.15em"}}>{code}</div></div><button onClick={()=>window.location.reload()} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700}}>Enter ContentSync</button></div></div>);
  return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:20,background:T.pageBg}}>
      <div style={{background:T.sideBg,border:"1px solid "+T.border,borderRadius:14,padding:"36px 32px",maxWidth:450,width:"100%"}}>
        <div style={{display:"flex",alignItems:"baseline",gap:6,justifyContent:"center",marginBottom:18}}><span style={{fontFamily:"'Playfair Display',serif",fontSize:28,fontWeight:700,color:T.gold}}>Content</span><span style={{fontFamily:"'Playfair Display',serif",fontSize:28,color:T.text}}>Sync</span></div>
        <div style={{textAlign:"center",marginBottom:18}}><div style={{fontSize:14,fontWeight:600,color:T.text,marginBottom:6}}>Hi {name} -- your free access has ended</div><div style={{fontSize:12,color:T.textSub,lineHeight:1.6}}>Your free access period ended July 17, 2026. Subscribe to continue -- all your data is saved and waiting.</div></div>
        <div style={{background:T.gold+"11",border:"1px solid "+T.gold+"33",borderRadius:10,padding:"14px",textAlign:"center",marginBottom:16}}><div style={{fontSize:24,fontWeight:700,color:T.gold,fontFamily:"'Playfair Display',serif"}}>$9.99<span style={{fontSize:12,fontWeight:400,color:T.textMuted}}>/month</span></div><div style={{fontSize:10,color:T.textMuted,marginTop:3}}>3-day free trial. Cancel anytime.</div></div>
        <div style={{display:"flex",flexDirection:"column",gap:9,marginBottom:12}}>
          <Inp label="Your Name" value={nm} onChange={setNm} placeholder="Your name"/>
          <Inp label="Email for your new access code" value={em} onChange={setEm} placeholder="your@email.com"/>
        </div>
        <div ref={ppRef} style={{marginBottom:8,opacity:(!em||!nm)?0.4:1,pointerEvents:(!em||!nm)?"none":"auto"}}/>
        {(!em||!nm)&&<div style={{fontSize:11,color:T.textMuted,textAlign:"center",marginBottom:8}}>Enter your name and email above</div>}
        {loading&&<div style={{textAlign:"center",color:T.textMuted,fontSize:12,padding:8}}>Setting up your access...</div>}
        {err&&<div style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",borderRadius:7,padding:"10px",fontSize:12,color:T.rose,marginBottom:8}}>{err}</div>}
        <button onClick={onOut} style={{width:"100%",background:"transparent",color:T.textMuted,border:"1px solid "+T.border,borderRadius:8,padding:"9px",fontSize:12}}>Sign Out</button>
      </div>
    </div>
  );
}


/* ── PAYPAL BUTTON COMPONENT (separate so it fully unmounts) ── */
function PayPalButton({nm,em,onSuccess,onError}){
  const containerRef=useRef(null);
  useEffect(()=>{
    if(!nm||!em)return;
    let active=true;
    loadPP(()=>{
      if(!active||!window.paypal||!containerRef.current)return;
      // Clear any existing buttons
      containerRef.current.innerHTML="";
      window.paypal.Buttons({
        style:{shape:"rect",color:"gold",layout:"vertical",label:"subscribe"},
        createSubscription:(d,a)=>a.subscription.create({plan_id:PAYPAL_PLAN_ID}),
        onApprove:async(d)=>{
          if(!active)return;
          try{
            const c=genCode();
            const stored=JSON.parse(localStorage.getItem(CODES_KEY)||"[]");
            stored.push({code:c,name:nm,email:em,subId:d.subscriptionID,date:new Date().toISOString()});
            localStorage.setItem(CODES_KEY,JSON.stringify(stored));
            await sendEmail(em,nm,c);
            await sendNotif(em,nm,c);
            onSuccess(c);
          }catch(e){onSuccess(genCode());}
        },
        onError:()=>{if(active)onError("Payment failed. Please try again.");}
      }).render(containerRef.current);
    });
    return()=>{
      active=false;
      if(containerRef.current) containerRef.current.innerHTML="";
    };
  },[nm,em]);
  return <div ref={containerRef}/>;
}

/* ── PAYWALL ── */

/* ── SLIDESHOW ── */
function Slideshow(){
  const slides = [
    {
      label: "BOOK DNA",
      title: "Surface Story vs Deeper Story",
      color: "#B89440",
      lines: [
        {k:"Surface Story", v:"A coastal architect is hired to renovate the estate of the man who destroyed her career — and discovers he's been waiting for her to come back."},
        {k:"Deeper Story", v:"A story about what it costs to rebuild after someone dismantles you on purpose, and whether the person who did it can earn the right to help you heal."},
        {k:"Themes", v:"Redemption • Betrayal • Control • Trust • Identity after failure"},
      ]
    },
    {
      label: "PITCHES",
      title: "From One-Sentence to Agent-Ready",
      color: "#3A8A7A",
      lines: [
        {k:"One-Sentence", v:"A disgraced architect is forced to renovate the mansion of the man who ruined her career — and falls for him anyway."},
        {k:"Social Pitch", v:"She swore she'd never work for him. He swore he'd never apologize. They were both wrong."},
        {k:"Bookstore Pick", v:"Enemies-to-lovers with real stakes, a coastal atmosphere you can taste, and a hero whose damage makes him heartbreaking rather than infuriating."},
      ]
    },
    {
      label: "HOOKS",
      title: "10 Hook Categories, Ready to Customize",
      color: "#C97060",
      lines: [
        {k:"Curiosity", v:"Nothing will prepare you for what happens in chapter 17."},
        {k:"Emotional", v:"I did not consent to these feelings and I am giving it 5 stars anyway."},
        {k:"Character", v:"He falls first. He falls hard. He has absolutely no idea what to do about it."},
        {k:"Teaser", v:"The slow burn enjoyers WON. This book is exactly what we have been waiting for."},
      ]
    },
    {
      label: "QUOTES",
      title: "Tracked by Chapter, Page & Type",
      color: "#B89440",
      lines: [
        {k:"Romantic  Ch. 14 p. 178", v:'"I am not a good man," he said. "I know," she said. "I am not asking you to be."'},
        {k:"Powerful  Ch. 21 p. 261", v:'"She did not forgive him. She just decided he was worth the risk of being wrong about."'},
        {k:"Best for Graphics  Ch. 25 p. 312", v:'"She built things for a living. He was the only thing she could not fix."'},
      ]
    },
    {
      label: "TIKTOK / REELS",
      title: "Content Pillars + Idea Banks",
      color: "#3A8A7A",
      lines: [
        {k:"Pillar: The Slow Burn", v:"Text Overlay: 'He noticed before he admitted it.' B-Roll: Hands near but not touching, turning pages in dim light."},
        {k:"Text Overlay", v:"'She is not forgiving him — she is deciding he is worth the risk'"},
        {k:"Video Concept", v:"Enemies to lovers timeline: showing every shift in the relationship chapter by chapter."},
      ]
    },
    {
      label: "BONUS TOP 10",
      title: "The Most Valuable Section for Your Client",
      color: "#C97060",
      lines: [
        {k:"Most Marketable Moment", v:"The scene where she realizes why he hired her — the whole dynamic shifts on one line of dialogue."},
        {k:"Best Line for Graphics", v:'"He practiced the words for six days before he said them."'},
        {k:"Most Likely to Go Viral", v:"The apology scene. Readers will not stop talking about it. BookTok will eat it alive."},
      ]
    },
  ];

  const [idx, setIdx] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(()=>{
    const interval = setInterval(()=>{
      setFade(false);
      setTimeout(()=>{
        setIdx(i => (i+1) % slides.length);
        setFade(true);
      }, 300);
    }, 4000);
    return ()=>clearInterval(interval);
  },[]);

  const goTo = (i) => {
    setFade(false);
    setTimeout(()=>{ setIdx(i); setFade(true); }, 200);
  };

  const slide = slides[idx];

  return(
    <div style={{width:340,flexShrink:0,display:"flex",flexDirection:"column",gap:10}}>
      <div style={{
        background:T.sideBg,border:"1px solid "+T.border,borderRadius:12,padding:"22px 20px",
        flex:1,transition:"opacity 0.3s",opacity:fade?1:0,
        borderLeft:"3px solid "+slide.color,
      }}>
        <div style={{fontSize:9,fontWeight:600,letterSpacing:"0.12em",textTransform:"uppercase",color:slide.color,marginBottom:6}}>{slide.label}</div>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:15,fontWeight:600,color:T.text,marginBottom:16,lineHeight:1.4}}>{slide.title}</div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {slide.lines.map((line,i)=>(
            <div key={i} style={{background:T.cardBg||T.deepBg,borderRadius:6,padding:"10px 12px"}}>
              <div style={{fontSize:8,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{line.k}</div>
              <div style={{fontSize:11,color:T.textSub,lineHeight:1.6}}>{line.v}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:6,alignItems:"center"}}>
        {slides.map((_,i)=>(
          <button key={i} onClick={()=>goTo(i)} style={{
            width:i===idx?20:6,height:6,borderRadius:3,border:"none",cursor:"pointer",
            background:i===idx?slide.color:T.border,
            transition:"all 0.3s",padding:0,
          }}/>
        ))}
      </div>
      <div style={{textAlign:"center",fontSize:10,color:T.textMuted,lineHeight:1.6}}>
        This is what your clients receive.<br/>
        <span style={{color:slide.color}}>Every section. Every book. Every time.</span>
      </div>
    </div>
  );
}

function Paywall({onUnlock}){
  const [screen,setScreen]=useState("home");
  const [em,setEm]=useState(""); const [nm,setNm]=useState("");
  const [code,setCode]=useState(""); const [entered,setEntered]=useState("");
  const [loading,setLoading]=useState(false); const [err,setErr]=useState("");

  const handleCode=()=>{
    setErr("");
    const leg=lookupLegacy(entered);
    if(leg){
      if(codeExpiredByCode(leg.code)){setErr("This access code ended on "+effectiveExpiry(leg.code)+". Please contact your provider to renew.");return;}
      if(graceExpired()&&leg.role==="user"){setErr("Your free trial period ended July 17, 2026. Please subscribe to continue.");return;}
      localStorage.setItem(ACCESS_KEY,JSON.stringify({code:leg.code,name:leg.name,email:leg.email,legacy:true,unlockedAt:new Date().toISOString()}));
      window.location.reload(); return;
    }
    const nw=lookupNew(entered);
    if(nw){
      if(codeExpiredByCode(nw.code,nw.expires)){setErr("This access code ended on "+effectiveExpiry(nw.code,nw.expires)+". Please contact your provider to renew.");return;}
      localStorage.setItem(ACCESS_KEY,JSON.stringify({code:nw.code,name:nw.name,email:nw.email,subscribed:true,expires:effectiveExpiry(nw.code,nw.expires),unlockedAt:new Date().toISOString()}));window.location.reload();return;
    }
    setErr("Invalid access code. Check your welcome email or contact support.");
  };

  const brand=(
    <div style={{textAlign:"center",marginBottom:22}}>
      <div style={{display:"flex",alignItems:"baseline",gap:0,justifyContent:"center",marginBottom:4}}>
        <span style={{fontFamily:"'Playfair Display',serif",fontSize:28,fontWeight:700,color:T.gold}}>Content</span>
        <span style={{fontFamily:"'Playfair Display',serif",fontSize:28,color:T.text}}>Sync</span>
      </div>
      <div style={{fontSize:11,color:T.textMuted,letterSpacing:"0.1em",textTransform:"uppercase"}}>Book Content Pull Studio</div>
    </div>
  );
  const card={background:T.sideBg,border:"1px solid "+T.border,borderRadius:14,padding:"32px 28px",maxWidth:440,width:"100%",margin:"0 auto"};

  if(screen==="home")return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:"20px",background:T.pageBg,overflowY:"auto"}}>
      <div style={{display:"flex",gap:24,alignItems:"stretch",width:"100%",maxWidth:860,margin:"0 auto"}}>
      <Slideshow/>
      <div style={{...card,flex:1,minWidth:0,margin:0}}>
        {brand}
        <div style={{fontSize:13,color:T.textSub,lineHeight:1.7,marginBottom:18}}>
          ContentSync is a <strong style={{color:T.text}}>professional organizer</strong> for book content pulls. You read the book, fill in the content, and ContentSync organizes everything into a polished client-ready export. <span style={{color:T.textMuted}}>No AI generation -- your words, your work, perfectly structured.</span>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:18}}>
          {["Organize hooks, quotes, tropes, and captions per book","Book DNA: surface story, themes, reader audience, comps","Pitch builder: one-sentence through agent-ready pitches","50+ hook and caption templates to guide your writing","Full trope library (150+ tropes) to tag and reference","TikTok/Reel idea banks with content pillars","Unlimited authors and books in one organized workspace","Export a formatted content pull document to send to clients"].map(f=>(<div key={f} style={{display:"flex",alignItems:"flex-start",gap:9,fontSize:12,color:T.textSub}}><span style={{color:T.teal,flexShrink:0,marginTop:1}}>v</span>{f}</div>))}
        </div>
        <div style={{background:T.gold+"11",border:"1px solid "+T.gold+"33",borderRadius:10,padding:"14px",textAlign:"center",marginBottom:16}}>
          <div style={{fontSize:24,fontWeight:700,color:T.gold,fontFamily:"'Playfair Display',serif"}}>$9.99<span style={{fontSize:12,fontWeight:400,color:T.textMuted}}>/month</span></div>
          <div style={{fontSize:11,color:T.textMuted,marginTop:3}}>3-day free trial. Cancel anytime via PayPal.</div>
        </div>
        <button onClick={()=>setScreen("subscribe")} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700,marginBottom:9}}>Subscribe with PayPal</button>
        <button onClick={()=>setScreen("code")} style={{width:"100%",background:"transparent",color:T.textMuted,border:"1px solid "+T.border,borderRadius:8,padding:"10px",fontSize:12}}>I already have an access code</button>
      </div>
      </div>
    </div>
  );

  if(screen==="subscribe")return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:20,background:T.pageBg}}>
      <div style={card}>
        {brand}
        <button onClick={()=>window.location.reload()} style={{background:"none",border:"none",color:T.textMuted,fontSize:12,marginBottom:14,padding:0,cursor:"pointer"}}>&lt; Back</button>
        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:14}}>
          <Inp label="Your Name" value={nm} onChange={setNm} placeholder="Your first name"/>
          <Inp label="Email Address" value={em} onChange={setEm} placeholder="Where to send your access code"/>
        </div>
        {(!nm||!em)&&<div style={{background:T.gold+"11",border:"1px solid "+T.gold+"33",borderRadius:8,padding:"10px",fontSize:12,color:T.textMuted,textAlign:"center",marginBottom:10}}>Enter your name and email above to load the payment options</div>}
        {nm&&em&&<PayPalButton nm={nm} em={em} onSuccess={(c)=>{setCode(c);setScreen("success");}} onError={setErr}/>}
        <div style={{background:T.deepBg,border:"1px solid "+T.border,borderRadius:8,padding:"12px 14px",marginTop:10}}>
          <div style={{fontSize:11,color:T.textMuted,lineHeight:1.7,textAlign:"center"}}>
            By subscribing you agree to a <strong style={{color:T.text}}>3-day free trial</strong>, after which you will be charged <strong style={{color:T.text}}>$9.99/month</strong> until you cancel. Cancel anytime via your PayPal account. No refunds for partial months.
          </div>
        </div>
        {loading&&<div style={{textAlign:"center",color:T.textMuted,fontSize:12,padding:8}}>Setting up your access...</div>}
        {err&&<div style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",borderRadius:7,padding:"10px",fontSize:12,color:T.rose,marginTop:8}}>{err}</div>}
      </div>
    </div>
  );

  if(screen==="success")return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:20,background:T.pageBg}}>
      <div style={{...card,textAlign:"center"}}>
        {brand}
        <div style={{fontSize:13,color:T.textSub,marginBottom:16}}>Welcome! Your code has been emailed to <strong style={{color:T.text}}>{em}</strong>. Save it here too.</div>
        <div style={{background:T.deepBg,border:"1px solid "+T.gold,borderRadius:10,padding:"20px",marginBottom:16}}>
          <div style={{fontSize:10,color:T.textMuted,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:8}}>Your Access Code</div>
          <div style={{fontFamily:"monospace",fontSize:22,fontWeight:700,color:T.gold,letterSpacing:"0.15em"}}>{code}</div>
        </div>
        <button onClick={()=>{const s=JSON.parse(localStorage.getItem(CODES_KEY)||"[]");const m=s.find(c=>c.code===code);if(m){localStorage.setItem(ACCESS_KEY,JSON.stringify({code,email:em,name:nm,subscribed:true,unlockedAt:new Date().toISOString()}));window.location.reload();}}} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700}}>Enter ContentSync</button>
      </div>
    </div>
  );

  if(screen==="code")return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100dvh",padding:20,background:T.pageBg}}>
      <div style={card}>
        {brand}
        <button onClick={()=>setScreen("home")} style={{background:"none",border:"none",color:T.textMuted,fontSize:12,marginBottom:14,padding:0,cursor:"pointer"}}>&lt; Back</button>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:17,fontWeight:600,color:T.text,marginBottom:6,textAlign:"center"}}>Enter Your Access Code</div>
        <div style={{fontSize:12,color:T.textSub,textAlign:"center",marginBottom:16,lineHeight:1.6}}>Existing users enter your <span style={{color:T.gold,fontFamily:"monospace"}}>SSDD-XXXXX</span> code. New subscribers use your <span style={{color:T.gold,fontFamily:"monospace"}}>SHELF-XXXXX</span> code.</div>
        <div style={{marginBottom:10}}><input value={entered} onChange={e=>setEntered(e.target.value.toUpperCase())} onKeyDown={e=>e.key==="Enter"&&handleCode()} placeholder="SSDD-XXXXX or SHELF-XXXXX" style={{fontFamily:"monospace",fontSize:16,letterSpacing:"0.08em",textAlign:"center"}}/></div>
        {err&&<div style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",borderRadius:7,padding:"10px",fontSize:12,color:T.rose,marginBottom:10}}>{err}</div>}
        <button onClick={handleCode} style={{width:"100%",background:T.gold,color:"#0D1821",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700,marginBottom:9}}>Unlock ContentSync</button>
        <div style={{textAlign:"center",fontSize:11,color:T.textMuted}}>No code? <button onClick={()=>setScreen("home")} style={{background:"none",border:"none",color:T.gold,cursor:"pointer",fontSize:11}}>Subscribe here</button></div>
      </div>
    </div>
  );
}

function TabHowTo(){
  const steps=[
    ["1","Start with the Author","Fill in the Author Profile (name, photo, social links, contact info). This info populates your export automatically."],
    ["2","Fill in Book Info","Add title, genre, series, publish date, format, ISBN. Upload the cover photo and book file if available."],
    ["3","Build the Book DNA","The DNA tab is your positioning foundation. Write the surface story, deeper story, themes, reader audience, and comp titles. This informs everything else."],
    ["4","Write Your Pitches","The Pitches tab builds from your DNA. Start with the one-sentence pitch, then expand to short, agent, publisher, and social pitches."],
    ["5","Build Your Hook Banks","Use the template banks as starting points. Fill in the blanks for each hook type -- curiosity, emotional, character, POV, teaser, fear, viral, and scroll-stopping."],
    ["6","Pull Quotes","In the Quotes tab, add quotes from the book with chapter and page numbers. Tag them by type (romantic, emotional, spice, etc.) for easy reference."],
    ["7","Tag Tropes & Dynamics","Select main tropes from the full library. Add hidden/micro-tropes and note character and relationship dynamics."],
    ["8","Build Character Profiles","Add a profile for each main character -- name, role, archetype, personality, reader appeal, content angles, and post ideas."],
    ["9","Complete Marketing & Captions","Fill in the USP, reader promise, target reader, and selling points. Then write captions for each type (release, review, reaction, etc.) using the idea banks."],
    ["10","TikTok & Reels","Select from the idea banks for video concepts, b-roll, formats, and text overlays. Build out your content pillars."],
    ["11","Add Graphics & Reviews","Upload any finished graphics, categorize them, and add review excerpts with links and star ratings."],
    ["12","Build Discussion & Engagement","In the Discussion tab, write book club questions, reader engagement prompts, poll ideas, and what-if scenarios for the author to use post-launch."],
    ["13","Complete Collabs","In the Collabs tab, build influencer outreach angles for BookTok, true crime creators, women's fiction readers, and book club influencers. Add bookstore, podcast, and library pitch notes."],
    ["14","Complete Bonus Top 10","The most valuable section for the author -- identify the top marketable moments, scream-worthy quotes, viral scenes, and best lines for graphics. This section alone is worth the pull."],
    ["15","Select Hashtags","Go to the Hashtags tab and select from 100+ curated BookTok and Bookstagram hashtags. Add any custom tags specific to the author or series."],
    ["16","Backup Your Work","Hit Backup in the sidebar to download a JSON copy of all your authors and books. Do this after every session -- your data auto-saves in the browser but a backup protects against clearing your cache."],
    ["17","Export","Click Export Pull in the top bar to download a formatted text file with all your content organized by section. Send it to the author or store it in your client folder."],
  ];
  return(
    <div style={{padding:"0 2px"}}>
      <div style={{background:T.panelBg,border:"1px solid "+T.gold+"55",borderRadius:10,padding:"16px 20px",marginBottom:20}}>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,fontWeight:600,color:T.gold,marginBottom:6}}>Welcome to ContentSync</div>
        <div style={{fontSize:13,color:T.textSub,lineHeight:1.7}}>ContentSync is a professional organizer for book content pulls. You do the creative work -- reading the book, writing the hooks, selecting the tropes -- and ContentSync structures it all into a polished, client-ready export document. No AI generation. Your words, your expertise, perfectly organized.</div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {steps.map(([num,title,desc])=>(
          <div key={num} style={{display:"flex",gap:14,padding:"14px 16px",background:T.panelBg,border:"1px solid "+T.border,borderRadius:10}}>
            <div style={{flexShrink:0,width:32,height:32,borderRadius:"50%",background:T.gold+"22",border:"1px solid "+T.gold+"55",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:T.gold}}>{num}</div>
            <div>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:14,fontWeight:600,color:T.text,marginBottom:4}}>{title}</div>
              <div style={{fontSize:12,color:T.textSub,lineHeight:1.6}}>{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── TAB: OVERVIEW ── */
function TabOverview({book,author}){
  const sec=(title,items)=>{
    const valid=items.filter(([,v])=>v&&(Array.isArray(v)?v.length>0:String(v).trim()));
    if(!valid.length)return null;
    return(
      <div key={title} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:8,padding:"12px 14px",marginBottom:10}}>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:13,fontWeight:600,color:T.gold,marginBottom:8,borderBottom:"1px solid "+T.border,paddingBottom:6}}>{title}</div>
        {valid.map(([label,val])=>(
          <div key={label} style={{marginBottom:8}}>
            <div style={{fontSize:10,fontWeight:600,letterSpacing:"0.07em",textTransform:"uppercase",color:T.textMuted,marginBottom:2}}>{label}</div>
            <div style={{fontSize:12,color:T.textSub,lineHeight:1.6}}>
              {Array.isArray(val)?val.join(", "):String(val).slice(0,300)+(String(val).length>300?"...":"")}
            </div>
          </div>
        ))}
      </div>
    );
  };
  const filled=Object.entries(book).filter(([k,v])=>v&&(Array.isArray(v)?v.length>0:String(v).trim())&&k!=="id").length;
  return(
    <div style={{padding:"0 2px"}}>
      <div style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:8,padding:"12px 14px",marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
        {book.coverPhoto&&<img src={book.coverPhoto} alt="" style={{width:50,height:66,objectFit:"cover",borderRadius:4,flexShrink:0}}/>}
        <div>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:600,color:T.text}}>{book.title||"Untitled"}</div>
          <div style={{fontSize:12,color:T.textMuted}}>by {author?.name||"Unknown Author"}</div>
          <div style={{fontSize:11,color:T.teal,marginTop:4}}>{filled} fields filled in</div>
        </div>
      </div>
      {sec("Book Details",[["Genre",(book.genres||[]).join(", ")],["Series",book.series+(book.seriesNum?" #"+book.seriesNum:"")],["Publisher",book.publisher],["Date",book.publishDate],["Format",book.format],["ISBN",book.isbn],["Status",book.status]])}
      {sec("Book DNA",[["Surface Story",book.surface_story],["Deeper Story",book.deeper_story],["Themes",book.themes],["Reader Audience",book.reader_audience],["Comp Authors",book.comp_authors]])}
      {sec("Pitches",[["One-Sentence",book.pitch_one_sentence],["Short Pitch",book.pitch_short]])}
      {sec("Blurb",[["Tagline",book.blurb_tagline],["Short Blurb",book.blurb_short],["Extended Blurb",book.blurb_extended]])}
      {sec("Playlist",[["Vibe",book.playlist_vibe],["Songs",(book.playlist||[]).filter(s=>s&&(s.title||s.artist)).map(s=>s.title+(s.artist?" – "+s.artist:"")).join(", ")]])}
      {sec("Tropes",[["Main Tropes",(book.tropes||[]).join(", ")],["Hidden Tropes",book.hidden_tropes],["Character Dynamics",book.char_dynamics]])}
      {sec("Marketing",[["USP",book.mkt_usp],["Why Readers Will Love It",book.mkt_why],["Reader Promise",book.mkt_promise]])}
      {sec("Social Links",[["TikTok",author?.tiktok],["Instagram",author?.instagram],["Goodreads",author?.goodreads],["Amazon",author?.amazon],["Website",author?.website]])}
    </div>
  );
}

/* ── TAB: BOOK INFO ── */
function TabInfo({book,upd,author,updAuthor,preparer,setPreparer}){
  const sA=f=>v=>updAuthor({...author,[f]:v});
  const sP=f=>v=>setPreparer({...(preparer||{}),[f]:v});
  return(<>
    <Coll title="Prepared By (You)" icon="🪪" open={true}>
      <Full>
        <div style={{fontSize:11,color:T.textMuted,marginBottom:12,lineHeight:1.6}}>This is <strong style={{color:T.text}}>you</strong> &mdash; the PA or marketer preparing the pull. It appears in the &ldquo;Prepared by&rdquo; line at the top of every export and in the page footer. Saved once and reused for every author and book.</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Inp label="Your Name" value={preparer?.name} onChange={sP("name")} placeholder="Your full name"/>
          <Inp label="Business Name" value={preparer?.business} onChange={sP("business")} placeholder="Business / brand (optional)"/>
          <Inp label="Email" type="email" value={preparer?.email} onChange={sP("email")} placeholder="you@email.com"/>
          <Inp label="Website" value={preparer?.website} onChange={sP("website")} placeholder="yoursite.com"/>
          <Inp label="TikTok" value={preparer?.tiktok} onChange={sP("tiktok")} placeholder="@handle"/>
          <Inp label="Instagram" value={preparer?.instagram} onChange={sP("instagram")} placeholder="@handle"/>
        </div>
      </Full>
    </Coll>
    <Coll title="Author Profile" icon="👤" open={true}>
      <Full>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Inp label="Author Name" value={author.name} onChange={sA("name")} placeholder="Full name"/>
          <Inp label="Email" type="email" value={author.email} onChange={sA("email")} placeholder="author@email.com"/>
          <Inp label="Phone" value={author.phone} onChange={sA("phone")} placeholder="+1 555 000 0000"/>
          <Inp label="TikTok" value={author.tiktok} onChange={sA("tiktok")} placeholder="@handle"/>
          <Inp label="Instagram" value={author.instagram} onChange={sA("instagram")} placeholder="@handle"/>
          <Inp label="Goodreads" value={author.goodreads} onChange={sA("goodreads")} placeholder="goodreads.com/..."/>
          <Inp label="Amazon Author Page" value={author.amazon} onChange={sA("amazon")} placeholder="amazon.com/..."/>
          <Inp label="Website" value={author.website} onChange={sA("website")} placeholder="https://..."/>
          <Inp label="Facebook" value={author.facebook} onChange={sA("facebook")} placeholder="facebook.com/..."/>
          <Inp label="YouTube" value={author.youtube} onChange={sA("youtube")} placeholder="youtube.com/..."/>
          <Inp label="Newsletter" value={author.newsletter} onChange={sA("newsletter")} placeholder="Newsletter URL"/>
          <Inp label="Linktree" value={author.linktree} onChange={sA("linktree")} placeholder="linktr.ee/..."/>
          <div style={{gridColumn:"1/-1"}}><Txt label="Author Notes" value={author.notes} onChange={sA("notes")} rows={2} placeholder="General notes about this author..."/></div>
        </div>
      </Full>
    </Coll>
    <Coll title="Book Details" icon="📚" open={true}>
      <Half><Inp label="Title" value={book.title} onChange={v=>upd("title",v)} placeholder="Book title"/></Half>
      <Half><Inp label="Subtitle" value={book.subtitle} onChange={v=>upd("subtitle",v)} placeholder="Subtitle (if any)"/></Half>
      <Full><TagPicker label="Genre" value={book.genres} onChange={v=>upd("genres",v)} options={GENRES}/></Full>
      <Half><Inp label="Series Name" value={book.series} onChange={v=>upd("series",v)} placeholder="Series name"/></Half>
      <Half><Inp label="Series Number" value={book.seriesNum} onChange={v=>upd("seriesNum",v)} placeholder="1, 2, 2.5"/></Half>
      <Half><Inp label="Publisher" value={book.publisher} onChange={v=>upd("publisher",v)} placeholder="Publisher"/></Half>
      <Half><Inp label="Publish Date" type="date" value={book.publishDate} onChange={v=>upd("publishDate",v)}/></Half>
      <Half><Sel label="Format" value={book.format} onChange={v=>upd("format",v)} options={FORMATS}/></Half>
      <Half><Inp label="ISBN" value={book.isbn} onChange={v=>upd("isbn",v)} placeholder="978-..."/></Half>
      <Half><Inp label="ASIN" value={book.asin} onChange={v=>upd("asin",v)} placeholder="Amazon ASIN"/></Half>
      <Half><Inp label="Page Count" value={book.page_count} onChange={v=>upd("page_count",v)} placeholder="e.g. 342"/></Half>
      <Half><Inp label="Word Count" value={book.word_count} onChange={v=>upd("word_count",v)} placeholder="e.g. 85000"/></Half>
      <Full>
        <label style={{display:"block",fontSize:10,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:6}}>Status</label>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {["Draft","In Progress","Complete","Sent"].map(st=>(<button key={st} onClick={()=>upd("status",st)} style={{flex:1,minWidth:70,padding:"7px 4px",borderRadius:6,border:"1px solid "+(book.status===st?T.gold:T.border),background:book.status===st?T.gold+"22":T.inputBg,color:book.status===st?T.gold:T.textMuted,fontSize:11,cursor:"pointer"}}>{st}</button>))}
        </div>
      </Full>
    </Coll>
    <Coll title="Files" icon="🗂️" open={true}>
      <Half><FileUp label="Cover Photo" preview={book.coverPhoto} name={book.coverPhotoName} accept="image/*" onChange={(u,n)=>{upd("coverPhoto",u);upd("coverPhotoName",n);}}/></Half>
      <Half><FileUp label="Book File (PDF/EPUB)" preview={book.bookFile} name={book.bookFileName} accept=".pdf,.epub,.mobi,.docx" onChange={(u,n)=>{upd("bookFile",u);upd("bookFileName",n);}}/></Half>
    </Coll>
    <Coll title="Notes" icon="📝">
      <Full><Txt value={book.notes} onChange={v=>upd("notes",v)} rows={4} placeholder="Notes, reminders, special instructions..."/></Full>
    </Coll>

      <Coll title="Export Accent Colors" icon="🎨">
        <div style={{fontSize:11,color:T.textMuted,marginBottom:12,lineHeight:1.6}}>Your export is always a clean, light, print-ready document. Pick one or two accent colors from the book's cover &mdash; they flow into the headings, section rules, labels, and quote borders. Leave blank for the default warm gold.</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {[
            ["accent","Primary Accent","#8B6F47","Headings, rules & labels"],
            ["accent2","Secondary Accent","#8B6F47","Quotes & TikTok sections"],
          ].map(([k,label,def,hint])=>(
            <div key={k}>
              <div style={{fontSize:9,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,marginBottom:4}}>{label}</div>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <input type="color" value={(book.exportTheme&&book.exportTheme[k])||def}
                  onChange={e=>{const t={...(book.exportTheme||{}),[k]:e.target.value};upd("exportTheme",t);}}
                  style={{width:32,height:32,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",background:"none",padding:2}}/>
                <div>
                  <div style={{fontSize:11,color:T.text}}>{(book.exportTheme&&book.exportTheme[k])||def}</div>
                  <div style={{fontSize:9,color:T.textMuted}}>{hint}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{fontSize:9,fontWeight:600,letterSpacing:"0.08em",textTransform:"uppercase",color:T.textMuted,margin:"14px 0 6px"}}>Quick Palettes</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {[
            ["Blood & Bone","#B11E22","#9C7A52"],
            ["Gold & Teal","#8B6F47","#4A7C7A"],
            ["Rose & Plum","#A8456B","#5E3A66"],
            ["Forest & Sage","#3F6B4A","#8A9A6B"],
            ["Ink & Slate","#2C3E66","#6B7280"],
            ["Sunset","#C0562F","#D99A4E"],
          ].map(([name,a,a2])=>(
            <button key={name} onClick={()=>upd("exportTheme",{accent:a,accent2:a2})}
              style={{display:"flex",alignItems:"center",gap:6,border:"1px solid "+T.border,borderRadius:20,padding:"4px 10px 4px 6px",background:T.inputBg,cursor:"pointer"}}>
              <span style={{display:"inline-flex"}}>
                <span style={{width:13,height:13,borderRadius:"50% 0 0 50%",background:a,display:"inline-block"}}/>
                <span style={{width:13,height:13,borderRadius:"0 50% 50% 0",background:a2,display:"inline-block"}}/>
              </span>
              <span style={{fontSize:10.5,color:T.text}}>{name}</span>
            </button>
          ))}
        </div>
        <button onClick={()=>upd("exportTheme",{})} style={{marginTop:14,background:"none",border:"1px solid "+T.border,borderRadius:5,padding:"5px 12px",fontSize:11,color:T.textMuted,cursor:"pointer"}}>Reset to Default</button>
      </Coll>
  </>);
}

/* ── TAB: BOOK DNA ── */
function TabDNA({book,upd}){
  return(<>
    <Coll title="Surface Story vs Deeper Story" icon="🧬" open={true}>
      <Full><Txt label="Surface Story" value={book.surface_story} onChange={v=>upd("surface_story",v)} rows={3} placeholder="The plot in one sentence -- what happens on the surface..."/></Full>
      <Full><Txt label="Deeper Story (Themes & Heart)" value={book.deeper_story} onChange={v=>upd("deeper_story",v)} rows={4} placeholder="The emotional/thematic core -- what it's really about..."/></Full>
    </Coll>
    <Coll title="Themes" icon="💡" open={true}>
      <Full><Txt label="Themes" value={book.themes} onChange={v=>upd("themes",v)} rows={5} placeholder="e.g. Survival, Courage, Hope, Female Resilience, Justice, Power and Control... (one per line or comma-separated)"/></Full>
    </Coll>
    <Coll title="Book DNA — Combined Positioning" icon="🔬">
      <Full><Txt label="Full Book DNA Statement" value={book.book_dna} onChange={v=>upd("book_dna",v)} rows={5} placeholder="Your complete book DNA statement -- surface + deeper + emotional hook combined..."/></Full>
      <Full><Txt label="DNA Notes" value={book.book_dna_notes} onChange={v=>upd("book_dna_notes",v)} rows={3} placeholder="Additional notes about positioning, tone, voice..."/></Full>
    </Coll>
    <Coll title="Reader Audience" icon="🎯">
      <Full><Txt label="Reader Audience" value={book.reader_audience} onChange={v=>upd("reader_audience",v)} rows={5} placeholder="Perfect for readers who enjoy: Karin Slaughter, Chevy Stevens... And readers who love: Strong female leads, Missing persons stories, Twisty thrillers..."/></Full>
    </Coll>
    <Coll title="Comparable Titles" icon="📚">
      <Half><Txt label="Comp Authors" value={book.comp_authors} onChange={v=>upd("comp_authors",v)} rows={4} placeholder="Authors with similar readership and tone..."/></Half>
      <Half><Txt label="Comp Books" value={book.comp_books} onChange={v=>upd("comp_books",v)} rows={4} placeholder="Specific titles that share audience, tone, or structure..."/></Half>
    </Coll>
  </>);
}

/* ── TAB: PITCHES ── */
function TabPitches({book,upd}){
  return(<>
    <Coll title="One-Sentence Pitch" icon="🎯" open={true}>
      <Full><Txt value={book.pitch_one_sentence} onChange={v=>upd("pitch_one_sentence",v)} rows={2} placeholder="A motel owner accidentally uncovers a trafficking network and must fight to survive after becoming one of its captives."/></Full>
    </Coll>
    <Coll title="Short Pitch" icon="📄" open={true}>
      <Full><Txt value={book.pitch_short} onChange={v=>upd("pitch_short",v)} rows={4} placeholder="2-3 sentence pitch for social media, email subjects, quick intros..."/></Full>
    </Coll>
    <Coll title="Agent Pitch" icon="🤝">
      <Full><Txt value={book.pitch_agent} onChange={v=>upd("pitch_agent",v)} rows={6} placeholder="Professional pitch for literary agents -- genre, themes, market positioning, comp titles, word count..."/></Full>
    </Coll>
    <Coll title="Publisher Pitch" icon="🏢">
      <Full><Txt value={book.pitch_publisher} onChange={v=>upd("pitch_publisher",v)} rows={6} placeholder="Commercial appeal, comp titles, audience, why it sells now..."/></Full>
    </Coll>
    <Coll title="Bookstore Pitch" icon="🏪">
      <Full><Txt value={book.pitch_bookstore} onChange={v=>upd("pitch_bookstore",v)} rows={4} placeholder="Quick pitch for indie bookstores, staff picks, display copy..."/></Full>
    </Coll>
    <Coll title="Book Club Pitch" icon="🎙️">
      <Full><Txt value={book.pitch_book_club} onChange={v=>upd("pitch_book_club",v)} rows={4} placeholder="Discussion-worthy themes, moral questions, emotional depth..."/></Full>
    </Coll>
    <Coll title="Social Media Pitch" icon="📱">
      <Full><Txt value={book.pitch_social} onChange={v=>upd("pitch_social",v)} rows={3} placeholder="Punchy social copy -- TikTok bio, Instagram bio, tweet-length..."/></Full>
    </Coll>
  </>);
}

/* ── TAB: HOOKS ── */
function TabHooks({book,upd}){
  const cats=[["curiosity","Curiosity"],["emotional","Emotional"],["character","Character"],["pov","POV"],["teaser","Teaser"],["fear","Fear/Tension"],["viral","Viral BookTok"],["scroll","Scroll-Stopping"],["pitch","One-Sentence Pitch"],["comment","Comment-Bait"]];
  const [ab,setAb]=useState("curiosity");
  return(<>
    <Coll title="Hook Template Bank" icon="📋" open={true}>
      <Full>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:8}}>
          {cats.map(([k,l])=><button key={k} onClick={()=>setAb(k)} style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+(ab===k?T.gold:T.border),background:ab===k?T.gold+"22":T.inputBg,color:ab===k?T.gold:T.textMuted,fontSize:11,cursor:"pointer"}}>{l}</button>)}
        </div>
        <BankPanel items={HOOK_BANKS[ab]||[]} onUse={t=>{const f="hooks_"+ab;upd(f,(book[f]?book[f]+"\n":"")+t);}}/>
      </Full>
    </Coll>
    {cats.map(([k,l])=>(
      <Coll key={k} title={l+" Hooks"} icon="🎣">
        <Full><Txt value={book["hooks_"+k]} onChange={v=>upd("hooks_"+k,v)} rows={6} placeholder={"Paste templates from above and customize, or write your own "+l.toLowerCase()+" hooks..."}/></Full>
      </Coll>
    ))}
  </>);
}

/* ── TAB: QUOTES ── */
function TabQuotes({book,upd}){
  const QTYPES=["Funny/Witty","Emotional","Romantic","Heartbreaking","Powerful/Badass","Spice","Fear/Tension","Suspense","General"];
  const quotes=Array.isArray(book.quotes)?book.quotes:[];
  const addQ=()=>upd("quotes",[...quotes,{id:uid(),text:"",type:"General",chapter:"",pg:"",line:"",notes:""}]);
  const updQ=(id,f,v)=>upd("quotes",quotes.map(q=>q.id===id?{...q,[f]:v}:q));
  const delQ=id=>upd("quotes",quotes.filter(q=>q.id!==id));
  return(<Coll title="Quote Bank" icon="💬" open={true}>
    <Full>
      {quotes.length===0&&<div style={{color:T.textMuted,fontSize:12,textAlign:"center",padding:16}}>No quotes added yet. Click below to start tracking quotes.</div>}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {quotes.map((q,i)=>(
          <div key={q.id} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:11,color:T.gold,fontWeight:600}}>Quote {i+1}</span>
              <button onClick={()=>delQ(q.id)} style={{background:"none",border:"none",color:T.rose,cursor:"pointer",fontSize:13}}>x</button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:7,marginBottom:7}}>
              <Sel label="Type" value={q.type} onChange={v=>updQ(q.id,"type",v)} options={QTYPES}/>
              <Inp label="Chapter" value={q.chapter} onChange={v=>updQ(q.id,"chapter",v)} placeholder="e.g. 4"/>
              <Inp label="Page #" value={q.pg} onChange={v=>updQ(q.id,"pg",v)} placeholder="e.g. 87"/>
              <Inp label="Line #" value={q.line} onChange={v=>updQ(q.id,"line",v)} placeholder="e.g. 12"/>
            </div>
            <Txt label="Quote Text" value={q.text} onChange={v=>updQ(q.id,"text",v)} rows={3} placeholder="Paste the quote exactly as it appears in the book..."/>
            <div style={{marginTop:7}}><Txt label="Notes" value={q.notes} onChange={v=>updQ(q.id,"notes",v)} rows={1} placeholder="Usage notes, context, why this quote works..."/></div>
          </div>
        ))}
      </div>
      <button onClick={addQ} style={{width:"100%",marginTop:8,background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:7,padding:"8px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Add Quote</button>
    </Full>
  </Coll>);
}

/* ── TAB: TROPES ── */
function TabTropes({book,upd}){
  return(<>
    <Coll title="Main Tropes" icon="🏷️" open={true}>
      <Full><TagPicker label="Full trope library - select or type your own" value={book.tropes} onChange={v=>upd("tropes",v)} options={ALL_TROPES}/></Full>
    </Coll>
    <Coll title="Hidden & Micro-Tropes" icon="🔍">
      <Full><Txt value={book.hidden_tropes} onChange={v=>upd("hidden_tropes",v)} rows={3} placeholder="Tropes that sneak up on the reader -- not obvious from the blurb..."/></Full>
    </Coll>
    <Coll title="Dynamics" icon="⚡">
      <Half><Txt label="Character Dynamics" value={book.char_dynamics} onChange={v=>upd("char_dynamics",v)} rows={4} placeholder="Grumpy/Sunshine, Alpha/Soft, Predator/Prey, Hunter/Hunted..."/></Half>
      <Half><Txt label="Relationship / Power Dynamics" value={book.rel_dynamics} onChange={v=>upd("rel_dynamics",v)} rows={4} placeholder="Push/pull, rivals to reluctant allies, captor/captive..."/></Half>
    </Coll>
  </>);
}

/* ── TAB: CHARACTERS ── */
function TabChars({book,upd}){
  const chars=book.characters||[];
  const addC=()=>upd("characters",[...chars,blankChar()]);
  const updC=(id,f,v)=>upd("characters",chars.map(c=>c.id===id?{...c,[f]:v}:c));
  const delC=id=>upd("characters",chars.filter(c=>c.id!==id));
  return(<>
    {chars.map((ch,idx)=>(
      <Coll key={ch.id} title={"Character "+(idx+1)+(ch.name?" -- "+ch.name:"")+(ch.role?" ("+ch.role+")":"")} icon="👤" open={idx===0}>
        {chars.length>1&&<Full><div style={{display:"flex",justifyContent:"flex-end"}}><button onClick={()=>delC(ch.id)} style={{background:"none",border:"1px solid "+T.border,color:T.rose,borderRadius:5,padding:"2px 9px",fontSize:11,cursor:"pointer"}}>Remove</button></div></Full>}
        <Half><Inp label="Name" value={ch.name} onChange={v=>updC(ch.id,"name",v)} placeholder="Character name"/></Half>
        <Half><Inp label="Role / Type" value={ch.role} onChange={v=>updC(ch.id,"role",v)} placeholder="Protagonist / Antagonist / Villain / Ally..."/></Half>
        <Half><Inp label="Archetype" value={ch.archetype} onChange={v=>updC(ch.id,"archetype",v)} placeholder="The Survivor, The Mastermind, The Enforcer..."/></Half>
        <Half><Inp label="Personality" value={ch.personality} onChange={v=>updC(ch.id,"personality",v)} placeholder="Key personality traits..."/></Half>
        <Full><Txt label="Description" value={ch.desc} onChange={v=>updC(ch.id,"desc",v)} rows={3} placeholder="Age, appearance, job, key physical/personality details..."/></Full>
        <Full><Txt label="Backstory" value={ch.backstory} onChange={v=>updC(ch.id,"backstory",v)} rows={3} placeholder="Relevant backstory -- what shaped this character..."/></Full>
        <Half><Txt label="Strengths" value={ch.strengths} onChange={v=>updC(ch.id,"strengths",v)} rows={3} placeholder="What makes this character compelling..."/></Half>
        <Half><Txt label="Weaknesses / Flaws" value={ch.weaknesses} onChange={v=>updC(ch.id,"weaknesses",v)} rows={3} placeholder="What makes this character human and relatable..."/></Half>
        <Full><Txt label="Reader Appeal" value={ch.reader_appeal} onChange={v=>updC(ch.id,"reader_appeal",v)} rows={2} placeholder="Why readers will connect with / root for / fear / love this character..."/></Full>
        <Full><Txt label="Content Angles" value={ch.content_angles} onChange={v=>updC(ch.id,"content_angles",v)} rows={3} placeholder="Best angles for content creation -- what to highlight about this character in posts, reels, graphics..."/></Full>
        <Full><Txt label="Moodboard / Aesthetic" value={ch.moodboard} onChange={v=>updC(ch.id,"moodboard",v)} rows={2} placeholder="Aesthetic searches, visual inspiration, vibes..."/></Full>
        <Full><Txt label="Character Post Ideas" value={ch.postideas} onChange={v=>updC(ch.id,"postideas",v)} rows={3} placeholder="Character intro reel, This or That post, aesthetic moodboard ideas..."/></Full>
      </Coll>
    ))}
    <button onClick={addC} style={{width:"100%",background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:7,padding:"9px",fontSize:13,fontWeight:600,marginTop:4}}>+ Add Character</button>
  </>);
}

/* ── TAB: MARKETING ── */
function TabMarketing({book,upd}){
  return(<>
    <Coll title="Unique Selling Proposition (USP)" icon="🏆" open={true}>
      <Full><Txt label="USP" value={book.mkt_usp} onChange={v=>upd("mkt_usp",v)} rows={4} placeholder="What does this book do that no other book in this genre does right now? What is the ONE thing that makes it unmissable?"/></Full>
      <Full><Txt label="Why Readers Will Love It" value={book.mkt_why} onChange={v=>upd("mkt_why",v)} rows={4} placeholder="The emotional core -- what will readers feel, remember, and tell others about?"/></Full>
    </Coll>
    <Coll title="Reader Promise" icon="🤝" open={true}>
      <Full><Txt label="Reader Promise" value={book.mkt_promise} onChange={v=>upd("mkt_promise",v)} rows={4} placeholder="What does this book PROMISE the reader on page one? What emotional experience are you delivering?"/></Full>
      <Full><Txt label="Promise Payoff" value={book.mkt_payoff} onChange={v=>upd("mkt_payoff",v)} rows={4} placeholder="How does the book DELIVER on that promise? What is the payoff moment readers feel they got exactly what was promised?"/></Full>
    </Coll>
    <Coll title="Target Reader Profile" icon="🎯">
      <Half><Txt label="Who Is Your Target Reader?" value={book.mkt_who} onChange={v=>upd("mkt_who",v)} rows={4} placeholder="Age range, reading habits, platform preference (BookTok vs Bookstagram vs Goodreads), what else they read..."/></Half>
      <Half><Txt label="Why This Reader Picks Your Book" value={book.mkt_why_them||""} onChange={v=>upd("mkt_why_them",v)} rows={4} placeholder="Why will THIS reader specifically choose this book? What itch does it scratch that their other reads don't?"/></Half>
    </Coll>
    <Coll title="Selling Points" icon="💰">
      <Half><Txt label="General Selling Points" value={book.mkt_selling} onChange={v=>upd("mkt_selling",v)} rows={5} placeholder="Standalone, HEA guaranteed, fast-paced, dual POV, diverse cast..."/></Half>
      <Half><Txt label="Genre-Specific Selling Points" value={book.mkt_genre_selling} onChange={v=>upd("mkt_genre_selling",v)} rows={5} placeholder="What this book does that the genre loves right now..."/></Half>
    </Coll>
    <Coll title="Comparable Reads" icon="📖">
      <Full><Txt value={book.mkt_comps} onChange={v=>upd("mkt_comps",v)} rows={4} placeholder="Fans of [Author] will love this. Feels like [Book] meets [Book]. Perfect for readers of [Title]..."/></Full>
    </Coll>
  </>);
}

/* ── TAB: CAPTIONS ── */
function TabCaptions({book,upd}){
  const cats=[["release","Release Week"],["review","Review Request"],["reaction","Reader Reaction"],["haveyouread","Have You Read This?"],["cover","Cover Reveal"]];
  const [ab,setAb]=useState("release");
  return(<>
    <Coll title="Caption Idea Bank" icon="📣" open={true}>
      <Full>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:8}}>
          {cats.map(([k,l])=><button key={k} onClick={()=>setAb(k)} style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+(ab===k?T.gold:T.border),background:ab===k?T.gold+"22":T.inputBg,color:ab===k?T.gold:T.textMuted,fontSize:11,cursor:"pointer"}}>{l}</button>)}
        </div>
        <BankPanel items={CAPTION_IDEAS[ab]||[]} onUse={t=>{const f="cap_"+ab;upd(f,(book[f]?book[f]+"\n\n":"")+t);}}/>
      </Full>
    </Coll>
    {cats.map(([k,l])=>(<Coll key={k} title={l+" Captions"} icon="📝"><Full><Txt value={book["cap_"+k]} onChange={v=>upd("cap_"+k,v)} rows={6} placeholder={"Use templates above as a starting point, then customize for this specific book and author..."}/></Full></Coll>))}
  </>);
}

/* ── TAB: TIKTOK ── */
function TabTikTok({book,upd}){
  const banks=[["ideas","Video Concepts",TIKTOK_CONCEPTS],["broll","B-Roll Suggestions",TIKTOK_BROLL],["formats","Trending Formats",TIKTOK_FORMATS],["overlays","Text Overlays",TIKTOK_OVERLAYS]];
  const [ab,setAb]=useState("ideas");
  return(<>
    <Coll title="TikTok/Reel Idea Bank" icon="🎬" open={true}>
      <Full>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:8}}>
          {banks.map(([k,l])=><button key={k} onClick={()=>setAb(k)} style={{padding:"5px 10px",borderRadius:6,border:"1px solid "+(ab===k?T.gold:T.border),background:ab===k?T.gold+"22":T.inputBg,color:ab===k?T.gold:T.textMuted,fontSize:12,cursor:"pointer"}}>{l}</button>)}
        </div>
        <BankPanel items={banks.find(([k])=>k===ab)?.[2]||[]} onUse={t=>{const f="tiktok_"+ab;upd(f,(book[f]?book[f]+"\n":"")+t);}}/>
      </Full>
    </Coll>
    <Coll title="Content Pillars" icon="🏛️" open={true}>
      <Full><Txt label="Content Pillars (with Text Overlays + B-Roll)" value={book.tiktok_content_pillars} onChange={v=>upd("tiktok_content_pillars",v)} rows={10} placeholder={"Build out your content pillars:\n\nPILLAR 1: [NAME]\nConcept: ...\nText Overlay: ...\nB-Roll: ...\n\nPILLAR 2: [NAME]\nConcept: ...\nText Overlay: ...\nB-Roll: ..."}/></Full>
    </Coll>
    {banks.map(([k,l])=>(<Coll key={k} title={l} icon="🎥"><Full><Txt value={book["tiktok_"+k]} onChange={v=>upd("tiktok_"+k,v)} rows={5} placeholder={"Your selected/customized "+l.toLowerCase()+" for this book..."}/></Full></Coll>))}
  </>);
}

/* ── TAB: GRAPHICS ── */
function TabGraphics({book,upd}){
  const graphics=book.graphics||[];
  const addG=()=>upd("graphics",[...graphics,blankGraphic()]);
  const updG=(id,f,v)=>upd("graphics",graphics.map(g=>g.id===id?{...g,[f]:v}:g));
  const delG=id=>upd("graphics",graphics.filter(g=>g.id!==id));
  const fRefs=useRef({});
  return(<>
    <Coll title="Graphics Library" icon="🖼️" open={true}>
      <Full>
        {graphics.length===0&&<div style={{color:T.textMuted,fontSize:12,textAlign:"center",padding:16}}>No graphics added yet.</div>}
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {graphics.map((g)=>(<div key={g.id} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:7,padding:"10px 12px"}}>
            <div style={{display:"flex",gap:8,alignItems:"flex-start"}}>
              <div style={{width:50,height:66,borderRadius:3,background:T.deepBg,overflow:"hidden",flexShrink:0,cursor:"pointer",border:"1px dashed "+T.border,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>fRefs.current[g.id]?.click()}>
                {g.file?<img src={g.file} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<span style={{fontSize:18,color:T.textMuted}}>+</span>}
                <input ref={el=>fRefs.current[g.id]=el} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>{updG(g.id,"file",ev.target.result);updG(g.id,"fileName",f.name);};r.readAsDataURL(f);}}/>
              </div>
              <div style={{flex:1,display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
                <Sel label="Type" value={g.type} onChange={v=>updG(g.id,"type",v)} options={GRAPHICS_TYPES}/>
                <Inp label="File Name" value={g.fileName} onChange={v=>updG(g.id,"fileName",v)} placeholder="filename.png"/>
                <div style={{gridColumn:"1/-1"}}><Txt label="Notes / Copy" value={g.notes} onChange={v=>updG(g.id,"notes",v)} rows={2} placeholder="Caption copy, usage notes..."/></div>
              </div>
              <button onClick={()=>delG(g.id)} style={{background:"none",border:"none",color:T.rose,cursor:"pointer",fontSize:15,padding:0}}>x</button>
            </div>
          </div>))}
        </div>
        <button onClick={addG} style={{width:"100%",marginTop:8,background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:7,padding:"8px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Add Graphic</button>
      </Full>
    </Coll>
    <Coll title="General Copy" icon="✍️">
      <Half><Txt label="Canva / Promo Copy" value={book.graphics_canva||""} onChange={v=>upd("graphics_canva",v)} rows={4} placeholder="Short punchy copy for promotional graphics..."/></Half>
      <Half><Txt label="Aesthetic Post Copy" value={book.graphics_aesthetic||""} onChange={v=>upd("graphics_aesthetic",v)} rows={4} placeholder="Mood words, vibe sentences for aesthetic posts..."/></Half>
    </Coll>
  </>);
}

/* ── TAB: DISCUSSION ── */
function TabDiscussion({book,upd}){
  return(<>
    <Coll title="Book Club Questions" icon="🎙️" open={true}><Full><Txt value={book.discuss_bookclub||""} onChange={v=>upd("discuss_bookclub",v)} rows={7} placeholder={"1. How did the setting influence the story?\n2. Which scene surprised you most?\n3. Which character would you trust with your life?\n4. What theme resonated most with you?\n5. Did you predict the ending?"}/></Full></Coll>
    <Coll title="Reader Engagement Questions" icon="💬"><Full><Txt value={book.discuss_engagement||""} onChange={v=>upd("discuss_engagement",v)} rows={5} placeholder={"Team [Character A] or Team [Character B]?\nWhat was your favourite scene?\nDid you predict the ending?\nWhich character would you be?"}/></Full></Coll>
    <Coll title="Poll Ideas" icon="📊"><Full><Txt value={book.discuss_polls||""} onChange={v=>upd("discuss_polls",v)} rows={4} placeholder={"Which villain was scarier: [A] or [B]?\nRate the tension: 1-5\nThis or That: [Character] vs [Character]"}/></Full></Coll>
    <Coll title="Story / What-If Prompts" icon="✍️"><Full><Txt value={book.discuss_prompts||""} onChange={v=>upd("discuss_prompts",v)} rows={4} placeholder="Creative writing prompts, alternate POV ideas, what-if scenarios..."/></Full></Coll>
  </>);
}

/* ── TAB: HASHTAGS ── */
function TabHashtags({book,upd}){
  const sel=book.hashtags_selected||[];
  const toggle=h=>upd("hashtags_selected",sel.includes(h)?sel.filter(x=>x!==h):[...sel,h]);
  const [q,setQ]=useState("");
  const fl=HASHTAGS_ALL.filter(h=>!q||h.toLowerCase().includes(q.toLowerCase()));
  return(<>
    <Coll title="Hashtag Library" icon="#️⃣" open={true}>
      <Full>
        <div style={{display:"flex",gap:6,marginBottom:7,flexWrap:"wrap"}}>
          <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Filter hashtags..." style={{flex:1,minWidth:120}}/>
          <button onClick={()=>upd("hashtags_selected",HASHTAGS_ALL)} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:5,padding:"5px 9px",fontSize:11,cursor:"pointer"}}>Select All</button>
          <button onClick={()=>upd("hashtags_selected",[])} style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",color:T.rose,borderRadius:5,padding:"5px 9px",fontSize:11,cursor:"pointer"}}>Clear</button>
          <button onClick={()=>navigator.clipboard.writeText(sel.join(" ")).catch(()=>{})} style={{background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:5,padding:"5px 9px",fontSize:11,cursor:"pointer"}}>Copy Selected</button>
        </div>
        <div style={{fontSize:10,color:T.textMuted,marginBottom:6}}>{sel.length} selected</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4,maxHeight:280,overflowY:"auto"}}>
          {fl.map(h=>(<button key={h} onClick={()=>toggle(h)} style={{background:sel.includes(h)?T.gold+"22":T.inputBg,border:"1px solid "+(sel.includes(h)?T.gold:T.border),color:sel.includes(h)?T.gold:T.textSub,borderRadius:4,padding:"3px 8px",fontSize:11,cursor:"pointer"}}>{h}</button>))}
        </div>
        {sel.length>0&&(<div style={{marginTop:8,background:T.deepBg,border:"1px solid "+T.border,borderRadius:5,padding:"7px 9px",cursor:"pointer"}} onClick={()=>navigator.clipboard.writeText(sel.join(" ")).catch(()=>{})}>
          <div style={{fontSize:10,color:T.textMuted,marginBottom:3}}>Click to copy all selected:</div>
          <div style={{fontSize:11,color:T.textSub,lineHeight:1.8}}>{sel.join(" ")}</div>
        </div>)}
      </Full>
    </Coll>
    <Coll title="Custom Hashtags" icon="➕"><Full><Txt value={book.hashtags_custom||""} onChange={v=>upd("hashtags_custom",v)} rows={3} placeholder="#YourNicheTag #AuthorSpecific #SeriesHashtag..."/></Full></Coll>
  </>);
}

/* ── TAB: REVIEWS ── */
function TabReviews({book,upd}){
  const reviews=book.reviews||[];
  const addR=()=>upd("reviews",[...reviews,blankReview()]);
  const updR=(id,f,v)=>upd("reviews",reviews.map(r=>r.id===id?{...r,[f]:v}:r));
  const delR=id=>upd("reviews",reviews.filter(r=>r.id!==id));
  return(<Coll title="Reviews & Endorsements" icon="⭐" open={true}>
    <Full>
      {reviews.length===0&&<div style={{color:T.textMuted,fontSize:12,textAlign:"center",padding:14}}>No reviews added yet.</div>}
      <div style={{display:"flex",flexDirection:"column",gap:9}}>
        {reviews.map((r,i)=>(<div key={r.id} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:7,padding:"10px 12px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
            <span style={{fontSize:11,color:T.gold,fontWeight:600}}>Review {i+1}</span>
            <button onClick={()=>delR(r.id)} style={{background:"none",border:"none",color:T.rose,cursor:"pointer",fontSize:13}}>x</button>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:7,marginBottom:7}}>
            <Inp label="Reviewer / Publication" value={r.reviewer} onChange={v=>updR(r.id,"reviewer",v)} placeholder="Reviewer name"/>
            <Sel label="Stars" value={r.stars} onChange={v=>updR(r.id,"stars",v)} options={["5","4","3","2","1"]}/>
            <Sel label="Type" value={r.type} onChange={v=>updR(r.id,"type",v)} options={["Reader","ARC","Press","Endorsement","Blurb","Award"]}/>
            <Inp label="Platform" value={r.platform} onChange={v=>updR(r.id,"platform",v)} placeholder="Goodreads, Amazon..."/>
          </div>
          <div style={{marginBottom:7}}><Txt label="Review Excerpt" value={r.excerpt} onChange={v=>updR(r.id,"excerpt",v)} rows={3} placeholder="Paste the review excerpt..."/></div>
          <div style={{display:"flex",gap:7,alignItems:"flex-end"}}>
            <div style={{flex:1}}><Inp label="Link / URL" value={r.link} onChange={v=>updR(r.id,"link",v)} placeholder="https://..."/></div>
            {r.link&&<a href={r.link} target="_blank" rel="noopener noreferrer" style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:5,padding:"7px 10px",fontSize:11,textDecoration:"none",whiteSpace:"nowrap"}}>Open</a>}
            <button onClick={()=>navigator.clipboard.writeText('"'+r.excerpt+'" - '+r.reviewer+(r.platform?" ("+r.platform+")":"")+" "+(r.link||"")).catch(()=>{})} style={{background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:5,padding:"7px 10px",fontSize:11,cursor:"pointer",whiteSpace:"nowrap"}}>Copy</button>
          </div>
        </div>))}
      </div>
      <button onClick={addR} style={{width:"100%",marginTop:8,background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:7,padding:"8px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Add Review</button>
    </Full>
  </Coll>);
}

/* ── TAB: COLLABS ── */
function TabCollabs({book,upd}){
  return(<>
    <Coll title="Influencer Collaboration — BookTok" icon="📱" open={true}>
      <Full><Txt label="Thriller/Suspense BookTok Angles" value={book.influencer_thriller} onChange={v=>upd("influencer_thriller",v)} rows={4} placeholder="Angles: Strong female lead, Human trafficking thriller, Survival suspense, Criminal conspiracy, Realistic fear..."/></Full>
    </Coll>
    <Coll title="Influencer Collaboration — True Crime Creators" icon="🎙️">
      <Full><Txt value={book.influencer_truecrime} onChange={v=>upd("influencer_truecrime",v)} rows={4} placeholder="Angles: Organized crime, Criminal networks, Human behavior, Survival psychology, Real-world parallels..."/></Full>
    </Coll>
    <Coll title="Influencer Collaboration — Women's Fiction / Empowerment" icon="👩">
      <Full><Txt value={book.influencer_womens} onChange={v=>upd("influencer_womens",v)} rows={4} placeholder="Angles: Female resilience, Strength under pressure, Determination, Courage, Breaking cycles..."/></Full>
    </Coll>
    <Coll title="Influencer Collaboration — Book Club Influencers" icon="📚">
      <Full><Txt value={book.influencer_bookclub} onChange={v=>upd("influencer_bookclub",v)} rows={4} placeholder="Angles: Discussion-worthy themes, Character analysis, Moral dilemmas, Reader debates, Complex relationships..."/></Full>
    </Coll>
    <Coll title="Influencer Outreach Message Template" icon="✉️">
      <Full><Txt value={book.influencer_outreach} onChange={v=>upd("influencer_outreach",v)} rows={6} placeholder="Hi [Name], I think [Title] would be a great fit for your audience because [reason]. The book is [one-sentence hook]. Perfect for readers who love [comp/trope]. I would love to send you an ARC."/></Full>
    </Coll>
    <Coll title="Independent Bookstores" icon="🏪">
      <Full><Txt value={book.collab_bookstores} onChange={v=>upd("collab_bookstores",v)} rows={4} placeholder="Thriller display, Staff pick feature, Signed copies, Book club selection, Local author events..."/></Full>
    </Coll>
    <Coll title="Podcasts & Media" icon="🎧">
      <Full><Txt value={book.collab_podcasts} onChange={v=>upd("collab_podcasts",v)} rows={4} placeholder="True crime podcasts, Book podcasts, Author interview shows, Relevant topic podcasts..."/></Full>
    </Coll>
    <Coll title="Libraries & Community" icon="🏛️">
      <Full><Txt value={book.collab_libraries} onChange={v=>upd("collab_libraries",v)} rows={4} placeholder="Library events, Community reads, Book club pitches, Author talks..."/></Full>
    </Coll>
  </>);
}

/* ── TAB: BLURB ── */
function TabBlurb({book,upd}){
  return(<>
    <Coll title="Tagline" icon="✨" open={true}>
      <Full><Txt value={book.blurb_tagline} onChange={v=>upd("blurb_tagline",v)} rows={2} placeholder="The one-line hook for the top of the blurb / retail listing -- e.g. 'Two monsters. One Target store. No survivors.'"/></Full>
    </Coll>
    <Coll title="Short Blurb (Retail / Back Cover)" icon="📕" open={true}>
      <Full><Txt value={book.blurb_short} onChange={v=>upd("blurb_short",v)} rows={6} placeholder="The punchy back-cover / Amazon description. 100-200 words, present tense, ends on a hook..."/></Full>
    </Coll>
    <Coll title="Extended Blurb" icon="📖">
      <Full><Txt value={book.blurb_extended} onChange={v=>upd("blurb_extended",v)} rows={8} placeholder="Longer version for the website, press kit, or newsletter -- more setup, stakes, and voice..."/></Full>
    </Coll>
    <Coll title="Elevator / 2-Line Blurb" icon="⚡">
      <Full><Txt value={book.blurb_elevator} onChange={v=>upd("blurb_elevator",v)} rows={2} placeholder="The 2-line version for bios, link-in-bio, quick DMs..."/></Full>
    </Coll>
    <Coll title="Content Warnings" icon="⚠️">
      <Full><Txt value={book.blurb_cw} onChange={v=>upd("blurb_cw",v)} rows={3} placeholder="Comma- or line-separated content warnings to include with the blurb..."/></Full>
    </Coll>
  </>);
}

/* ── TAB: PLAYLIST ── */
function TabPlaylist({book,upd}){
  const songs=Array.isArray(book.playlist)?book.playlist:[];
  const addS=()=>upd("playlist",[...songs,{id:uid(),title:"",artist:"",note:""}]);
  const updS=(id,f,v)=>upd("playlist",songs.map(s=>s.id===id?{...s,[f]:v}:s));
  const delS=id=>upd("playlist",songs.filter(s=>s.id!==id));
  const move=(id,dir)=>{
    const i=songs.findIndex(s=>s.id===id); if(i<0)return;
    const j=i+dir; if(j<0||j>=songs.length)return;
    const copy=songs.slice(); const [it]=copy.splice(i,1); copy.splice(j,0,it); upd("playlist",copy);
  };
  return(<>
    <Coll title="Playlist Vibe" icon="🎧" open={true}>
      <Half><Txt label="Overall Vibe / Theme" value={book.playlist_vibe} onChange={v=>upd("playlist_vibe",v)} rows={3} placeholder="The mood the playlist captures -- moody, obsessive, slow-burn dread, chaotic..."/></Half>
      <Half><Inp label="Streaming Link (optional)" value={book.playlist_link} onChange={v=>upd("playlist_link",v)} placeholder="Spotify / Apple Music URL"/></Half>
    </Coll>
    <Coll title="Songs" icon="🎵" open={true}>
      <Full>
        {songs.length===0&&<div style={{color:T.textMuted,fontSize:12,textAlign:"center",padding:16}}>No songs added yet. Build the book's playlist below.</div>}
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {songs.map((s,i)=>(
            <div key={s.id} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:8,padding:"10px 12px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <span style={{fontSize:11,color:T.gold,fontWeight:600}}>Track {i+1}</span>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <button onClick={()=>move(s.id,-1)} disabled={i===0} title="Move up" style={{background:"none",border:"1px solid "+T.border,color:i===0?T.border:T.textMuted,borderRadius:4,padding:"1px 6px",fontSize:11,cursor:i===0?"default":"pointer"}}>↑</button>
                  <button onClick={()=>move(s.id,1)} disabled={i===songs.length-1} title="Move down" style={{background:"none",border:"1px solid "+T.border,color:i===songs.length-1?T.border:T.textMuted,borderRadius:4,padding:"1px 6px",fontSize:11,cursor:i===songs.length-1?"default":"pointer"}}>↓</button>
                  <button onClick={()=>delS(s.id)} style={{background:"none",border:"none",color:T.rose,cursor:"pointer",fontSize:13}}>x</button>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,marginBottom:7}}>
                <Inp label="Song Title" value={s.title} onChange={v=>updS(s.id,"title",v)} placeholder="Song name"/>
                <Inp label="Artist" value={s.artist} onChange={v=>updS(s.id,"artist",v)} placeholder="Artist name"/>
              </div>
              <Inp label="Note (optional)" value={s.note} onChange={v=>updS(s.id,"note",v)} placeholder="Which character / scene / moment this song is for..."/>
            </div>
          ))}
        </div>
        <button onClick={addS} style={{width:"100%",marginTop:8,background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:7,padding:"8px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Add Song</button>
      </Full>
    </Coll>
  </>);
}

/* ── TAB: BONUS TOP 10 ── */
function TabBonus({book,upd}){
  const fields=[
    ["bonus_moments","Top 10 Most Marketable Moments","The 10 scenes/moments most likely to go viral or get screenshotted and shared\n\n1.\n2.\n3."],
    ["bonus_quotes","Top 10 Scream-Worthy Quotes","The 10 lines that will make readers lose their minds\n\n1.\n2.\n3."],
    ["bonus_relatable","Top 10 Most Relatable Moments","Moments readers will screenshot and tag their friends in\n\n1.\n2.\n3."],
    ["bonus_emotional","Top 10 Most Emotional Scenes","Scenes that need their own trigger warning for feelings\n\n1.\n2.\n3."],
    ["bonus_graphics","Top 10 Best Lines for Graphics","Lines short and powerful enough to stop the scroll on a graphic\n\n1.\n2.\n3."],
    ["bonus_arcs","Top 10 Best Character Arc Moments","The moments showing the most growth or shift in a character\n\n1.\n2.\n3."],
    ["bonus_scenes","Top 10 Scenes Most Likely to Go Viral","Specific, concrete, shareable moments BookTok will obsess over\n\n1.\n2.\n3."],
    ["bonus_lines","Top 10 Lines That Hit Harder on Reread","Lines with foreshadowing, double meaning, or new weight the second time\n\n1.\n2.\n3."],
  ];
  return <>{fields.map(([k,l,p])=>(<Coll key={k} title={l} icon="🏆"><Full><Txt value={book[k]||""} onChange={v=>upd(k,v)} rows={7} placeholder={p}/></Full></Coll>))}</>;
}

/* ── TAB: SOURCES ── */
/* ── TAB: AUTHOR NOTES ── */
function TabNotes({book,upd}){
  return(<>
    <Coll title="About This Tab" icon="📌" open={true}>
      <Full>
        <div style={{fontSize:12,color:T.textMuted,lineHeight:1.7}}>
          A private workspace for raw material the <strong style={{color:T.text}}>author</strong> gives you &mdash; context, relationship facts, worldbuilding, dynamics, &ldquo;don&rsquo;t spoil X.&rdquo; This is your reference while you build the pull. It is <strong style={{color:T.text}}>not</strong> included in the client export unless you switch on the toggle below.
        </div>
      </Full>
    </Coll>
    <Coll title="Author-Supplied Notes" icon="🗒️" open={true}>
      <Full><Txt value={book.author_notes} onChange={v=>upd("author_notes",v)} rows={10} placeholder={"Paste anything the author sent for context...\n\ne.g. Relationship dynamic, spoiler-free facts, character backstory, tone references, things to avoid."}/></Full>
    </Coll>
    <Coll title="Relationship Facts / Dynamic" icon="💞">
      <Full><Txt value={book.author_relationship} onChange={v=>upd("author_relationship",v)} rows={8} placeholder={"Relationship facts, the central dynamic, what drives the tension between the leads..."}/></Full>
    </Coll>
    <Coll title="Worldbuilding / Series Context" icon="🗺️">
      <Full><Txt value={book.author_world} onChange={v=>upd("author_world",v)} rows={6} placeholder={"Setting, series continuity, rules of the world, anything that carries across books..."}/></Full>
    </Coll>
    <Coll title="Do Not Spoil / Guardrails" icon="🚫">
      <Full><Txt value={book.author_guardrails} onChange={v=>upd("author_guardrails",v)} rows={4} placeholder={"Plot points to keep out of marketing, sensitive content, the author's hard limits..."}/></Full>
    </Coll>
    <Coll title="Export Setting" icon="⚙️">
      <Full>
        <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",padding:"4px 0"}}>
          <input type="checkbox" checked={!!book.author_notes_export} onChange={e=>upd("author_notes_export",e.target.checked)} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontSize:12.5,color:T.text}}>Include these notes in the client PDF export</span>
        </label>
        <div style={{fontSize:11,color:T.textMuted,marginTop:6,lineHeight:1.6}}>Off by default. Leave off to keep author notes as your private reference; turn on only if the author wants this context in the deliverable.</div>
      </Full>
    </Coll>
  </>);
}

function TabSources({book}){
  const [q,setQ]=useState("");
  const genres=book.genres?.length?book.genres:["General"];
  const seen=new Set();const sources=[];
  [...genres,"General"].forEach(g=>(SOURCE_LIB[g]||[]).forEach(s=>{if(!seen.has(s)){seen.add(s);sources.push({s,g});}}));
  const fl=sources.filter(({s})=>!q||s.toLowerCase().includes(q.toLowerCase()));
  return(<div>
    <div style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:7,padding:"10px 12px",marginBottom:10}}>
      <div style={{fontFamily:"'Playfair Display',serif",fontSize:13,fontWeight:600,color:T.text,marginBottom:3}}>Filtered for: <span style={{color:T.gold}}>{genres.join(", ")}</span></div>
      <div style={{fontSize:11,color:T.textMuted}}>Set genres on Book Info to see relevant sources here.</div>
    </div>
    <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Filter sources..." style={{marginBottom:8}}/>
    <div style={{display:"flex",flexDirection:"column",gap:6}}>
      {fl.map(({s,g},i)=>(<div key={i} style={{background:T.panelBg,border:"1px solid "+T.border,borderRadius:7,padding:"9px 12px"}}>
        <div style={{fontSize:12,fontWeight:500,color:T.text}}>{s}</div>
        <div style={{fontSize:10,color:T.textMuted,marginTop:2}}>{g}</div>
      </div>))}
    </div>
  </div>);
}

/* ── BOOK CARD ── */
function BookCard({book,active,onSelect,onDelete}){
  const sc={Draft:T.textMuted,"In Progress":T.gold,Complete:T.teal,Sent:T.rose};
  return(
    <div onClick={()=>onSelect(book.id)} style={{background:active?T.cardBg+"44":"transparent",border:"1px solid "+(active?T.gold+"55":T.border),borderRadius:7,padding:"8px 10px",cursor:"pointer",display:"flex",gap:8,alignItems:"flex-start",transition:"background .12s"}} onMouseEnter={e=>{if(!active)e.currentTarget.style.background=T.panelBg;}} onMouseLeave={e=>{if(!active)e.currentTarget.style.background="transparent";}}>
      <div style={{width:30,height:42,borderRadius:3,background:T.deepBg,overflow:"hidden",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:T.textMuted}}>
        {book.coverPhoto?<img src={book.coverPhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:"B"}
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:11,fontWeight:600,color:T.text,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{book.title||"Untitled"}</div>
        <div style={{fontSize:10,color:T.textMuted,marginTop:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{book.genres?.slice(0,1).join(",")||"No genre"}</div>
        <span style={{fontSize:9,background:sc[book.status]+"22",color:sc[book.status],border:"1px solid "+sc[book.status]+"44",borderRadius:3,padding:"1px 5px",display:"inline-block",marginTop:2}}>{book.status}</span>
      </div>
      <button onClick={e=>{e.stopPropagation();onDelete(book.id);}} style={{background:"none",border:"none",color:T.border,cursor:"pointer",fontSize:13,padding:0,lineHeight:1}} onMouseEnter={e=>e.currentTarget.style.color=T.rose} onMouseLeave={e=>e.currentTarget.style.color=T.border}>x</button>
    </div>
  );
}

/* ── TABS CONFIG ── */
const TABS=[
  {id:"howto",    label:"How To Use"},
  {id:"overview", label:"Overview"},
  {id:"info",     label:"Book Info"},
  {id:"notes",    label:"Author Notes"},
  {id:"dna",      label:"Book DNA"},
  {id:"pitches",  label:"Pitches"},
  {id:"blurb",    label:"Blurb"},
  {id:"hooks",    label:"Hooks"},
  {id:"quotes",   label:"Quotes"},
  {id:"tropes",   label:"Tropes"},
  {id:"chars",    label:"Characters"},
  {id:"mkt",      label:"Marketing"},
  {id:"captions", label:"Captions"},
  {id:"tiktok",   label:"TikTok/Reels"},
  {id:"playlist", label:"Playlist"},
  {id:"graphics", label:"Graphics"},
  {id:"discuss",  label:"Discussion"},
  {id:"hash",     label:"Hashtags"},
  {id:"reviews",  label:"Reviews"},
  {id:"collabs",  label:"Collabs"},
  {id:"bonus",    label:"Bonus Top 10"},
  {id:"sources",  label:"Sources"},
];

/* ── MAIN APP ── */
export default function App(){
  const [light,setLight]=useState(()=>{
    try{const l=localStorage.getItem(THEME_KEY)==="light";T=l?lightT:darkT;return l;}catch(e){return false;}
  });
  const toggleTheme=()=>{
    const nl=!light;setLight(nl);T=nl?lightT:darkT;
    try{localStorage.setItem(THEME_KEY,nl?"light":"dark");}catch(e){}
  };

  const [session]=useState(()=>{try{const a=localStorage.getItem(ACCESS_KEY);return a?JSON.parse(a):null;}catch(e){return null;}});
  const [unlocked]=useState(()=>!!session);
  const isAdmin=session?.code==="SSDD-ADMIN7655";
  const isLegacy=session?.legacy===true;
  const userName=session?.name||"";
  const isGraceExpired=graceExpired()&&isLegacy&&session?.code!=="SSDD-ADMIN7655"&&session?.code!=="SSDD-BETA2026";
  // Scheduled deactivation: any logged-in user (legacy or generated) loses access
  // once their scheduled end date passes. We read the universal expiry store live,
  // so changing the date in Admin takes effect immediately, even mid-session.
  const isCodeExpired=(()=>{
    if(!session||isAdmin) return false;
    return codeExpiredByCode(session.code, session.expires);
  })();
  const [showAdmin,setShowAdmin]=useState(false);

  const [authors,setAuthors]=useState(()=>{
    try{
      // Try new key first, fall back to old keys for migration
      const s=localStorage.getItem(STORE_KEY)||localStorage.getItem("shelfsync_v1")||localStorage.getItem("contentsync_v1");
      if(s){const d=JSON.parse(s);if(d.authors?.length)return d.authors;}
    }catch(e){}
    return[blankAuthor()];
  });

  // PREPARER — the PA / marketer who prepares the pulls. One profile, reused for
  // every author/book. Drives the "Prepared by" line in the header and footer.
  const [preparer,setPreparer]=useState(()=>{
    try{const p=localStorage.getItem(PREPARER_KEY);if(p)return JSON.parse(p);}catch(e){}
    return {name:(session?.name||""),email:"",website:"",tiktok:"",instagram:"",business:""};
  });
  useEffect(()=>{
    try{localStorage.setItem(PREPARER_KEY,JSON.stringify(preparer));}catch(e){}
  },[preparer]);
  const [selAId,setSelAId]=useState(()=>authors[0]?.id);
  const [selBId,setSelBId]=useState(()=>authors[0]?.books[0]?.id);
  const [activeTab,setActiveTab]=useState("info");
  const [sideOpen,setSideOpen]=useState(true);
  const [aSearch,setASearch]=useState("");
  const [toast,setToast]=useState(null);
  const impRef=useRef();

  useEffect(()=>{
    if(!unlocked)return;
    try{localStorage.setItem(STORE_KEY,JSON.stringify({authors,savedAt:new Date().toISOString()}));}catch(e){}
  },[authors,unlocked]);

  const signOut=()=>{if(window.confirm("Sign out? Your data stays saved.")){localStorage.removeItem(ACCESS_KEY);window.location.reload();}};

  const updAuthor=useCallback(u=>setAuthors(as=>as.map(a=>a.id===u.id?u:a)),[]);
  const upd=useCallback((f,v)=>setAuthors(as=>as.map(a=>a.id===selAId?{...a,books:a.books.map(b=>b.id===selBId?{...b,[f]:v}:b)}:a)),[selAId,selBId]);

  const author=authors.find(a=>a.id===selAId);
  const book=author?.books?.find(b=>b.id===selBId);

  if(!unlocked) return <Paywall onUnlock={()=>window.location.reload()}/>;
  if(isCodeExpired) return <CodeExpiredScreen name={userName} onOut={()=>{localStorage.removeItem(ACCESS_KEY);window.location.reload();}}/>;
  if(isGraceExpired) return <GraceExpiredScreen name={userName} onOut={()=>{localStorage.removeItem(ACCESS_KEY);window.location.reload();}}/>;
  if(showAdmin&&isAdmin) return <AdminPanel onExit={()=>setShowAdmin(false)} authors={authors} setAuthors={setAuthors}/>;

  const addAuthor=()=>{const na=blankAuthor();setAuthors(as=>[...as,na]);setSelAId(na.id);setSelBId(na.books[0].id);setActiveTab("info");};
  const delAuthor=id=>{const next=authors.filter(a=>a.id!==id);const rem=next.length?next:[blankAuthor()];setAuthors(rem);if(selAId===id){setSelAId(rem[0].id);setSelBId(rem[0].books[0]?.id);}};
  const addBook=()=>{const nb=blankBook();setAuthors(as=>as.map(a=>a.id===selAId?{...a,books:[...a.books,nb]}:a));setSelBId(nb.id);setActiveTab("info");};
  const delBook=id=>{setAuthors(as=>as.map(a=>{if(a.id!==selAId)return a;const next=a.books.filter(b=>b.id!==id);return{...a,books:next.length?next:[blankBook()]};}));if(selBId===id){const o=author?.books?.find(b=>b.id!==id);if(o)setSelBId(o.id);}};

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(null),2500);};
  const handleBackup=()=>{exportBackup(authors);showToast("Backup downloaded!");};
  const handleImport=e=>{
    const file=e.target.files[0];if(!file)return;
    const r=new FileReader();
    r.onload=ev=>{
      try{
        const d=JSON.parse(ev.target.result);
        if(!d.authors?.length)throw new Error();
        // Migrate old books to add new fields
        const migrated=d.authors.map(a=>({...blankAuthor(),...a,books:(a.books||[]).map(b=>({...blankBook(),...b}))}));
        setAuthors(migrated);setSelAId(migrated[0].id);setSelBId(migrated[0].books[0]?.id);
        showToast("Restored! "+migrated.length+" author"+(migrated.length!==1?"s":"")+" loaded.");
      }catch(err){showToast("Could not read backup file.");}
    };
    r.readAsText(file);e.target.value="";
  };

  const filtA=authors.filter(a=>!aSearch||(a.name||"").toLowerCase().includes(aSearch.toLowerCase()));

  // Completion score
  const cpFields=["title","surface_story","pitch_one_sentence","hooks_curiosity","hooks_emotional","quotes","tropes","mkt_usp","tiktok_content_pillars","hashtags_selected","bonus_moments"];
  const filled=cpFields.filter(f=>{const v=book?.[f];return Array.isArray(v)?v.length>0:!!(v||"").trim();}).length;
  const pct=book?Math.round((filled/cpFields.length)*100):0;

  const renderTab=()=>{
    if(!book||!author)return null;
    switch(activeTab){
      case"howto":    return <TabHowTo/>;
      case"overview": return <TabOverview book={book} author={author}/>;
      case"info":     return <TabInfo book={book} upd={upd} author={author} updAuthor={u=>updAuthor({...author,...u})} preparer={preparer} setPreparer={setPreparer}/>;
      case"notes":    return <TabNotes book={book} upd={upd}/>;
      case"dna":      return <TabDNA book={book} upd={upd}/>;
      case"pitches":  return <TabPitches book={book} upd={upd}/>;
      case"blurb":    return <TabBlurb book={book} upd={upd}/>;
      case"hooks":    return <TabHooks book={book} upd={upd}/>;
      case"quotes":   return <TabQuotes book={book} upd={upd}/>;
      case"tropes":   return <TabTropes book={book} upd={upd}/>;
      case"chars":    return <TabChars book={book} upd={upd}/>;
      case"mkt":      return <TabMarketing book={book} upd={upd}/>;
      case"captions": return <TabCaptions book={book} upd={upd}/>;
      case"tiktok":   return <TabTikTok book={book} upd={upd}/>;
      case"playlist": return <TabPlaylist book={book} upd={upd}/>;
      case"graphics": return <TabGraphics book={book} upd={upd}/>;
      case"discuss":  return <TabDiscussion book={book} upd={upd}/>;
      case"hash":     return <TabHashtags book={book} upd={upd}/>;
      case"reviews":  return <TabReviews book={book} upd={upd}/>;
      case"collabs":  return <TabCollabs book={book} upd={upd}/>;
      case"bonus":    return <TabBonus book={book} upd={upd}/>;
      case"sources":  return <TabSources book={book}/>;
      default:        return null;
    }
  };

  return(
    <>
      <style>{GS(light?lightT:darkT)}</style>
      <div style={{display:"flex",flexDirection:"column",height:"100dvh",overflow:"hidden",background:T.pageBg}}>
        {isLegacy&&!isAdmin&&<GraceBanner name={userName}/>}
        <div style={{display:"flex",flex:1,overflow:"hidden"}}>

          {/* SIDEBAR */}
          {sideOpen&&(
            <div style={{width:260,display:"flex",flexDirection:"column",background:T.sideBg,borderRight:"1px solid "+T.border,flexShrink:0,overflow:"hidden"}}>
              {/* Brand + controls */}
              <div style={{padding:"12px 12px 10px",borderBottom:"1px solid "+T.border}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
                  <span style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700}}>
                    <span style={{color:T.gold}}>Content</span><span style={{color:T.text}}>Sync</span>
                  </span>
                  <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>
                    {isAdmin&&<button onClick={()=>setShowAdmin(true)} style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",color:T.rose,borderRadius:5,padding:"3px 7px",fontSize:10,cursor:"pointer"}}>Admin</button>}
                    <button onClick={toggleTheme} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:5,padding:"3px 7px",fontSize:10,cursor:"pointer"}}>{light?"Dark":"Light"}</button>
                    <button onClick={handleBackup} style={{background:T.teal+"22",border:"1px solid "+T.teal+"55",color:T.teal,borderRadius:5,padding:"3px 7px",fontSize:10,cursor:"pointer"}}>Backup</button>
                    <button onClick={()=>impRef.current.click()} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:5,padding:"3px 7px",fontSize:10,cursor:"pointer"}}>Restore</button>
                    <input ref={impRef} type="file" accept=".json" style={{display:"none"}} onChange={handleImport}/>
                    <button onClick={signOut} style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",color:T.rose,borderRadius:5,padding:"3px 7px",fontSize:10,cursor:"pointer"}}>Sign Out</button>
                  </div>
                </div>
                <div style={{fontSize:9,color:T.textMuted}}>Auto-saves. Use Backup to download a copy.</div>
              </div>

              {/* Author list */}
              <div style={{padding:"8px 10px 6px",borderBottom:"1px solid "+T.border}}>
                <div style={{display:"flex",gap:5,marginBottom:5}}>
                  <input value={aSearch} onChange={e=>setASearch(e.target.value)} placeholder="Search authors..." style={{flex:1,fontSize:11,padding:"5px 8px"}}/>
                  <button onClick={addAuthor} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:5,padding:"4px 8px",fontSize:11,fontWeight:600,flexShrink:0,cursor:"pointer"}}>+ Author</button>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:3,maxHeight:150,overflowY:"auto"}}>
                  {filtA.map(a=>(
                    <div key={a.id} onClick={()=>{setSelAId(a.id);setSelBId(a.books[0]?.id);}} style={{background:selAId===a.id?T.gold+"22":"transparent",border:"1px solid "+(selAId===a.id?T.gold+"55":T.border),borderRadius:5,padding:"6px 8px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{minWidth:0,flex:1}}>
                        <div style={{fontSize:11,fontWeight:600,color:selAId===a.id?T.gold:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.name||"Unnamed Author"}</div>
                        <div style={{fontSize:9,color:T.textMuted}}>{a.books.length} book{a.books.length!==1?"s":""}</div>
                      </div>
                      {authors.length>1&&<button onClick={e=>{e.stopPropagation();delAuthor(a.id);}} style={{background:"none",border:"none",color:T.border,cursor:"pointer",fontSize:12,padding:"1px"}} onMouseEnter={e=>e.currentTarget.style.color=T.rose} onMouseLeave={e=>e.currentTarget.style.color=T.border}>x</button>}
                    </div>
                  ))}
                </div>
              </div>

              {/* Book list */}
              {author&&(<>
                <div style={{padding:"6px 10px 3px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:9,fontWeight:600,letterSpacing:"0.07em",textTransform:"uppercase",color:T.textMuted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:150}}>{author.name||"Author"}'s Books</span>
                  <button onClick={addBook} style={{background:T.gold+"22",border:"1px solid "+T.gold+"55",color:T.gold,borderRadius:4,padding:"2px 7px",fontSize:10,fontWeight:600,cursor:"pointer",flexShrink:0}}>+ Book</button>
                </div>
                <div style={{flex:1,overflowY:"auto",padding:"3px 8px 10px",display:"flex",flexDirection:"column",gap:4}}>
                  {author.books.map(b=>(<BookCard key={b.id} book={b} active={b.id===selBId} onSelect={id=>{setSelBId(id);setActiveTab("info");}} onDelete={delBook}/>))}
                </div>
              </>)}
            </div>
          )}

          {/* MAIN PANEL */}
          <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",minWidth:0}}>
            {/* Top bar */}
            <div style={{background:T.sideBg,borderBottom:"1px solid "+T.border,padding:"8px 12px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
              <button onClick={()=>setSideOpen(o=>!o)} style={{background:"none",border:"1px solid "+T.border,color:T.textMuted,borderRadius:5,padding:"4px 7px",fontSize:11,flexShrink:0,cursor:"pointer"}}>{sideOpen?"<":">"}</button>
              {book&&(<>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:14,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{book.title||"Untitled Book"}</div>
                  <div style={{fontSize:10,color:T.textMuted}}>{author?.name||"Author"}{book.series?" -- "+book.series:""}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                  <div style={{width:60,height:3,background:T.border,borderRadius:2,overflow:"hidden"}}>
                    <div style={{width:pct+"%",height:"100%",background:pct===100?T.teal:T.gold,borderRadius:2,transition:"width .3s"}}/>
                  </div>
                  <span style={{fontSize:9,color:T.textMuted,whiteSpace:"nowrap"}}>{pct}%</span>
                </div>
                <button onClick={()=>{exportText(author,book,preparer);showToast("Content pull exported!");}} style={{background:T.rose+"22",border:"1px solid "+T.rose+"55",color:T.rose,borderRadius:6,padding:"6px 12px",fontSize:11,fontWeight:600,whiteSpace:"nowrap",cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.background=T.rose+"33"} onMouseLeave={e=>e.currentTarget.style.background=T.rose+"22"}>Export Pull</button>
              </>)}
            </div>

            {/* Tab bar */}
            <div style={{background:T.sideBg,borderBottom:"1px solid "+T.border,padding:"0 8px",display:"flex",gap:0,overflowX:"auto",flexShrink:0,WebkitOverflowScrolling:"touch"}}>
              {TABS.map(t=>(<button key={t.id} onClick={()=>setActiveTab(t.id)} style={{background:"none",border:"none",borderBottom:"2px solid "+(activeTab===t.id?T.gold:"transparent"),color:activeTab===t.id?T.gold:T.textMuted,padding:"9px 10px 7px",fontSize:11,fontWeight:activeTab===t.id?600:400,cursor:"pointer",whiteSpace:"nowrap",transition:"color .12s"}}>{t.label}</button>))}
            </div>

            {/* Content */}
            <div style={{flex:1,overflowY:"auto",padding:"14px 16px",WebkitOverflowScrolling:"touch",background:T.pageBg}}>
              {book?renderTab():(
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",gap:10,color:T.textMuted}}>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,color:T.textMuted}}>Select a book or create a new content pull</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {toast&&<div style={{position:"fixed",bottom:20,left:"50%",transform:"translateX(-50%)",background:T.teal,color:"#fff",borderRadius:7,padding:"9px 18px",fontSize:12,fontWeight:600,zIndex:999,boxShadow:"0 4px 16px #0009",whiteSpace:"nowrap"}}>{toast}</div>}
      </div>
    </>
  );
}
